<template>
  <div class="assembleOrder">
    <div class="header">
      <el-tabs :value="tabPaneValue" @tab-click="tabPaneClick">
        <el-tab-pane label="组装工单" name="first">
          <span
            class="childTabs"
            :class="{ activeLink: cutView == true }"
            @click="cutViewChange(true)"
            >组装工单</span
          >
          <span
            class="childTabs"
            :class="{ activeLink: cutView == false }"
            @click="cutViewChange(false)"
            >图表视图</span
          >
          <div class="btnBox">
            <div class="searchBtnBox" style="margin-right:15px">
              <el-tooltip v-if="cutView" class="item" content="只看我的工单" placement="bottom" :open-delay="300">
                <el-checkbox v-model="searchConditionForm.onlyMy" @change="onlyMyChange">我的工单</el-checkbox>
              </el-tooltip>
            </div>
            <div class="searchBtnBox" v-if="isMoreSearch">
              <el-tooltip
                class="item"
                content="清除查询条件"
                placement="bottom"
                :open-delay="300"
              >
                <el-button
                  icon="iconfont icon-qingkong"
                  size="small"
                  class="cleanBox"
                  @click="onClear"
                ></el-button>
              </el-tooltip>
              <el-button
                type="primary"
                icon="el-icon-search"
                size="small"
                @click="onSearch"
                >查询</el-button
              >
            </div>
            <!-- <el-button type="primary" icon="el-icon-plus" size="small" @click="addNewBtn">新建</el-button> -->
            <el-tooltip
              class="item"
              content="查询条件"
              placement="bottom"
              :open-delay="300"
            >
              <el-button
                class="btn_more"
                :class="{ activeUserMore: isMoreSearch }"
                size="small"
                icon="el-icon-d-arrow-right"
                @click="moreSearchBtn"
              ></el-button>
            </el-tooltip>
          </div>
        </el-tab-pane>
        <el-tab-pane
          v-for="(item, index) in tabPaneList"
          :key="item.id"
          :label="item.orderNumber"
          :name="item.id"
        >
          <span slot="label">
            {{ item.orderNumber }}
            <i
              class="el-icon-circle-close"
              @click.stop="closeTabPane(index)"
            ></i>
          </span>
          <span
            class="childTabs"
            :class="{ activeLink: cutDetail == 'detail' }"
            @click="cutDetailChange('detail')"
            >工单详情</span
          >
          <span
            class="childTabs"
            :class="{ activeLink: cutDetail == 'devices' }"
            @click="cutDetailChange('devices')"
            >产品列表</span
          >
          <span v-if="item.product.hasPart"
            class="childTabs"
            :class="{ activeLink: cutDetail == 'partList' }"
            @click="cutDetailChange('partList')"
            >配件列表</span
          >
          <span
            class="childTabs"
            :class="{ activeLink: cutDetail == 'status' }"
            @click="cutDetailChange('status')"
            >生产状态</span
          >
          <span
            class="childTabs"
            :class="{ activeLink: cutDetail == 'process' }"
            @click="cutDetailChange('process')"
            >生产工序</span
          >
          <span
            class="childTabs"
            :class="{ activeLink: cutDetail == 'QCReport' }"
            @click="cutDetailChange('QCReport')"
            >QC记录</span
          >
          <span
            class="childTabs"
            :class="{ activeLink: cutDetail == 'RepairRecordPage' }"
            @click="cutDetailChange('RepairRecordPage')"
            >维修记录</span
          >
          <span
            class="childTabs"
            :class="{ activeLink: cutDetail == 'QcCheckList' }"
            @click="cutDetailChange('QcCheckList')"
            >检验单</span
          >
          <span
            class="childTabs"
            :class="{ activeLink: cutDetail == 'proLog' }"
            @click="cutDetailChange('proLog')"
            >生产日志</span
          >
          <span v-if="tabPaneData.customer && tabPaneData.customer.id=='148759996952887296'"
            class="childTabs"
            :class="{ activeLink: cutDetail == 'uploadLog' }"
            @click="cutDetailChange('uploadLog')"
            >上报日志</span
          >
          <div class="btnBox"
            v-if="cutDetail == 'detail' && detailStatus.code != 'LOCKED' && detailStatus.code != 'CLOSED'">
            <el-button v-if="(cutDetail == 'detail' || cutDetail == 'status') && detailStatus && detailStatus.code=='PRODUCTION'" type="primary" size="small" @click="pauseOrder($event, detailData, true)">暂停</el-button>
            <el-button type="primary" size="small" @click="detailStatusBtn">{{
              detailStatusText
            }}</el-button>
          </div>
          <div v-if="cutDetail == 'status' && proStatus == '产品状态' && detailStatus.code != 'LOCKED' && detailStatus.code != 'CLOSED'"
            class="btnBox">
            <el-button type="primary" size="small" @click="resetError">释放烧录失败</el-button>
            <el-button type="primary" size="small" @click="otaByStatus">按工序OTA</el-button>
            <el-button type="primary" size="small" @click="lockByStatus">按工序锁定</el-button>
            <el-button type="primary" size="small" @click="unLock" title="警告！部分产品会更换UUID！！！">解除异常锁定</el-button>
            <el-button type="primary" size="small" @click="resetUnpacked">重置未包装</el-button>
            <el-button type="primary" size="small" @click="detailStatusBtn">{{detailStatusText}}</el-button>
          </div>
          <div class="btnBox" v-else-if="cutDetail == 'devices'">
            <div style="display:inline;margin-right:20px;">
              <input
                ref="uploadSnInput"
                type="file"
                @change="uploadSnChange(index)"
                :webkitdirectory="uploadType == 'folder'"
                style="display: none"
              />
              <el-button type="primary" size="small" v-if="showImportSnUuidBtn"
                @click="uploadSnBtn(index, 'file')"
              >导入SN/UUID</el-button>
              <el-button type="primary" size="small" v-else-if="showLinkViewImportBtn"
                @click="uploadSnBtn(index, 'file')"
              >导入SN/UUID</el-button>
              <el-button type="primary" size="small" v-if="showD070UuidImportBtn"
                @click="uploadSnBtn(index, 'file')"
              >导入UUID</el-button>
              <input
                ref="uploadUUIDInput"
                type="file"
                @change="uploadUUIDChange(index)"
                :webkitdirectory="uploadType == 'folder'"
                style="display: none"
              />
              <input
                ref="uploadMacInput"
                type="file"
                @change="uploadMacChange(index)"
                style="display: none"
              />
              <input
                ref="uploadVoiceInput"
                type="file"
                @change="uploadVoiceChange(index)"
                style="display: none"
              />
              <input
                ref="uploadUuidInput"
                type="file"
                @change="uploadUuidChange(index)"
                style="display: none"
              />              
              <input
                ref="uploadImeiInput"
                type="file"
                @change="uploadImeiChange()"
                style="display: none"
              />
              <el-button
                v-if="!(tabPaneData.customer && tabPaneData.customer.id=='215434450273710080') && tabPaneData.product.code!='D070' && tabPaneData.macSupport && tabPaneData.macSupport.code=='BY_ORDER' && tabPaneData.macFid == 0"
                type="primary"
                size="small" style="margin-left:10px"
                @click="uploadMacBtn(index, 'file')"
                >导入MAC</el-button
              >
              <el-button
                v-if="(tabPaneData.product.p2pType && (tabPaneData.product.p2pType.code=='XiaoCao' || tabPaneData.product.p2pType.code=='WuXiao' || tabPaneData.product.p2pType.code=='WuXiaoByTuya')) && tabPaneData.snFid == 0"
                type="primary"
                size="small" style="margin-left:10px"
                @click="uploadImeiBtn(index, 'file')"
                >导入IMEI</el-button
              >
              <el-button
                v-if="(tabPaneData.product.productType && (tabPaneData.product.productType.code=='SMART_WEARABLES')) && tabPaneData.imeiFid == 0 && (!tabPaneData.product.p2pType || tabPaneData.product.p2pType.code!='QiHu360')"
                type="primary"
                size="small" style="margin-left:10px"
                @click="uploadImeiBtn(index, 'file')"
                >导入IMEI</el-button
              >
              <el-button
                v-if="(tabPaneData.product.productType && (tabPaneData.product.productType.code=='SMART_WEARABLES')) && tabPaneData.uuidFid == 0 && (!tabPaneData.product.p2pType || tabPaneData.product.p2pType.code!='QiHu360')"
                type="primary"
                size="small" style="margin-left:10px"
                @click="uploadUuidBtn(index, 'file')"
                >导入NET_ID</el-button
              >
              <!-- QiHu360产品导入语音授权码 -->
              <el-button
                v-if="tabPaneData.snFid == 0 && tabPaneData.product && tabPaneData.product.p2pType && (tabPaneData.product.p2pType.code=='QiHu360' || tabPaneData.product.p2pType.code=='QiHu360_4G')"
                type="primary"
                size="small" style="margin-left:10px"
                @click="uploadSnBtn(index, 'file')"
                >导入SN</el-button
              >              
              <el-button
                v-if="tabPaneData.product && tabPaneData.product.voice && tabPaneData.macFid == 0"
                type="primary"
                size="small" style="margin-left:10px"
                @click="uploadVoiceBtn(index, 'file')"
                >导入语音授权码</el-button
              >
              <el-button
                v-if="tabPaneData.product && tabPaneData.product.adas && tabPaneData.uuidFid == 0"
                type="primary"
                size="small" style="margin-left:10px"
                @click="uploadUuidBtn(index, 'file')"
                >导入ADAS授权码</el-button
              >
              <!-- 创新客户导入外箱SN -->
              <el-button
                v-if="tabPaneData.customer && tabPaneData.customer.id=='67333133305126912' && tabPaneData.uuidFid == 0"
                type="primary"
                size="small" style="margin-left:10px"
                @click="uploadSnBtn(index, 'file')"
                >导入外箱SN</el-button
              >
              <!-- 杭州棠联 -->
              <el-button type="primary" size="small" v-if="tabPaneData.customer && tabPaneData.customer.id=='145780042883543040' && tabPaneData.uuidFid == 0"
                @click="uploadUuidBtn(index, 'file')"
              >导入UUID</el-button>
              <!-- 瑞讯云 -->
              <el-button type="primary" size="small" v-if="tabPaneData.customer && tabPaneData.customer.id=='159013968612569088' && tabPaneData.uuidFid == 0"
                @click="uploadUuidBtn(index, 'file')"
              >导入UUID</el-button>
              <!-- 濠越、欧度利方、联想（慧海智算） -->
              <el-button type="primary" size="small" v-if="tabPaneData.customer && (tabPaneData.customer.id=='171316797001834496' || tabPaneData.customer.id=='167431119314767872' || tabPaneData.customer.id=='169499496981078016') && tabPaneData.product.importSn && (tabPaneData.product.productType.code=='AI_PC' || tabPaneData.product.productType.code=='AI_SERVER') && tabPaneData.uuidFid == 0"
                @click="uploadUuidBtn(index, 'file')"
              >导入DPK</el-button>
              <!-- 贵州新智造 -->
              <el-button type="primary" size="small" v-if="tabPaneData.customer && tabPaneData.customer.id=='167955989069971456' && tabPaneData.product.importSn && (tabPaneData.product.productType.code=='AI_PC' || tabPaneData.product.productType.code=='AI_SERVER') && tabPaneData.snFid == 0"
                @click="uploadSnBtn(index, 'file')"
              >导入客户SN</el-button>
              <!-- 融讯科技 -->
              <el-button type="primary" size="small" v-if="tabPaneData.customer && tabPaneData.customer.id=='185649153063927808' && tabPaneData.snFid == 0"
                @click="uploadSnBtn(index, 'file')"
              >导入PMD文件</el-button>
              <el-button type="primary" size="small" v-if="tabPaneData.customer && tabPaneData.customer.id=='185649153063927808' && tabPaneData.uuidFid == 0"
                @click="uploadUuidBtn(index, 'file')"
              >导入配置文件</el-button>
              <!-- Owlet -->
              <el-button type="primary" size="small" v-if="tabPaneData.customer && tabPaneData.customer.id=='55276351018774528' && tabPaneData.snFid == 0"
                @click="uploadUuidBtn(index, 'file')"
              >导入UUID</el-button>
              <!-- Nimble Wireless INC -->
              <el-button type="primary" size="small" v-if="tabPaneData.customer && tabPaneData.customer.id=='190899307638566912' && tabPaneData.snFid == 0"
                @click="uploadSnBtn(index, 'file')"
              >导入SN</el-button>
              <!-- 优计算科技 -->
              <el-button type="primary" size="small" v-if="tabPaneData.customer && tabPaneData.customer.id=='168450514856062976' && tabPaneData.product.importSn && tabPaneData.snFid == 0"
                @click="uploadSnBtn(index, 'file')"
              >导入SN</el-button>
              <!-- 广联智通 -->
              <el-button type="primary" size="small" v-if="tabPaneData.customer && tabPaneData.customer.id=='215434450273710080' && tabPaneData.snFid == 0"
                @click="uploadSnBtn(index, 'file')"
              >导入Excel(SN和密钥)</el-button>
              <el-button type="primary" size="small" v-if="tabPaneData.customer && tabPaneData.customer.id=='215434450273710080' && tabPaneData.macFid == 0"
                @click="uploadMacBtn(index, 'file')"
              >导入Zip(MAC和证书)</el-button>
            </div>
            <div class="searchBtnBox" v-if="isMoreSearch" style="margin-left:0px;">
              <el-button v-if="tabPaneData.status && tabPaneData.status.code=='PRODUCTION'"
                  class="downIcon"
                  type="primary"
                  icon="el-icon-lock"
                  size="small"
                  @click="batchUnLockDevice"
              >解锁异常</el-button>
              <el-button v-if="tabPaneData.status && tabPaneData.status.code=='PRODUCTION'"
                  class="downIcon"
                  type="primary"
                  icon="el-icon-lock"
                  size="small"
                  @click="batchLockDevice"
              >异常锁定</el-button>
              <el-tooltip
                class="item"
                content="清除查询条件"
                placement="bottom"
                :open-delay="300"
              >
                <el-button
                  icon="iconfont icon-qingkong"
                  size="small"
                  class="cleanBox"
                  @click="onClear"
                ></el-button>
              </el-tooltip>
              <el-dropdown trigger="click" @command="tableExport">
                <el-button
                  class="downIcon"
                  type="primary"
                  icon="el-icon-d-arrow-right"
                  size="small"
                  >导出</el-button
                >
                <el-dropdown-menu slot="dropdown" class="devicesDownloadDrop">
                  <el-dropdown-item command="组装单报表">组装单报表</el-dropdown-item>
                  <el-dropdown-item command="发货单报表">发货单报表</el-dropdown-item>
                  <el-dropdown-item v-if="tabPaneData.product && ((tabPaneData.product.voice && tabPaneData.macFid == 0) || (tabPaneData.product.adas && tabPaneData.uuidFid==0))" command="导出MAC">导出MAC</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
              <el-dropdown
                split-button
                type="primary"
                size="small"
                class="searchBox"
                @click="onSearch(false)"
                trigger="click"
              >
                查询
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item @click.native="onSearch(true)"
                    >模糊查询</el-dropdown-item
                  >
                </el-dropdown-menu>
              </el-dropdown>
            </div>
            <el-tooltip
              class="item"
              content="查询条件"
              placement="bottom"
              :open-delay="300"
            >
              <el-button
                class="btn_more"
                :class="{ activeUserMore: isMoreSearch }"
                size="small"
                icon="el-icon-d-arrow-right"
                @click="moreSearchBtn"
              ></el-button>
            </el-tooltip>
          </div>
          <div class="btnBox" v-else-if="cutDetail == 'partList'">
            <el-button style="margin-right:10px"
              v-if="tabPaneData.product.code=='D161-4G配件'"
              type="primary"
              icon="el-icon-upload2"
              size="small"
              @click="uploadImeiBtn(index)"
              >导入IMEI</el-button
            >
            <input
              v-if="tabPaneData.product.code=='D161-4G配件'"
              ref="uploadImeiInput"
              type="file"
              @change="uploadImeiChange()"
              style="display: none"
            />
            <el-button
              v-if="tabPaneData.product.code=='B210'"
              type="primary"
              icon="el-icon-upload2"
              size="small"
              @click="uploadBatteryBtn(index, 'file')"
              >电池SN</el-button
            >
            <input
              v-if="tabPaneData.product.code=='B210'"
              ref="uploadBatteryInput"
              type="file"
              @change="uploadBatteryChange(index)"
              style="display: none"
            />
            <div class="searchBtnBox" v-if="isMoreSearch">
              <el-tooltip
                class="item"
                content="清除查询条件"
                placement="bottom"
                :open-delay="300"
              >
                <el-button
                  icon="iconfont icon-qingkong"
                  size="small"
                  class="cleanBox"
                  @click="onClear"
                ></el-button>
              </el-tooltip>
              <el-dropdown
                split-button
                type="primary"
                size="small"
                class="searchBox"
                @click="onSearch(false)"
                trigger="click"
              >
                查询
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item @click.native="onSearch(true)"
                    >模糊查询</el-dropdown-item
                  >
                </el-dropdown-menu>
              </el-dropdown>
            </div>
            <el-tooltip
              class="item"
              content="查询条件"
              placement="bottom"
              :open-delay="300"
            >
              <el-button
                class="btn_more"
                :class="{ activeUserMore: isMoreSearch }"
                size="small"
                icon="el-icon-d-arrow-right"
                @click="moreSearchBtn"
                style="margin-left: 0px"
              ></el-button>
            </el-tooltip>
          </div>
          <div class="btnBox" v-else-if="cutDetail == 'process'">
            <el-button v-if="productSopData && productSopData.length==0"
              type="primary"
              icon="el-icon-document-copy"
              size="small"
              @click="copySopBtn"
              >复制工序</el-button>
            <el-button
              type="primary"
              icon="el-icon-plus"
              size="small"
              @click="addNewBtn"
              >添加</el-button
            >
          </div>
          <div class="btnBox" v-else-if="cutDetail == 'QCReport'">
            <div class="searchBtnBox" v-if="isMoreSearch">
              <el-dropdown trigger="click" @command="QCReportExport">
                <el-button class="downIcon" type="primary" icon="el-icon-d-arrow-right" size="small">导出</el-button>
                <el-dropdown-menu slot="dropdown" class="devicesDownloadDrop">
                  <el-dropdown-item command="导出报表">导出报表</el-dropdown-item>
                  <el-dropdown-item command="FQC明细报表">只导FQC人员的报表</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
              <el-tooltip
                class="item"
                content="清除查询条件"
                placement="bottom"
                :open-delay="300"
              >
                <el-button
                  icon="iconfont icon-qingkong"
                  size="small"
                  class="cleanBox"
                  @click="onClear"
                ></el-button>
              </el-tooltip>
              <el-button
                type="primary"
                icon="el-icon-search"
                size="small"
                @click="onSearch"
                >查询</el-button
              >
            </div>
            <el-tooltip
              class="item"
              content="查询条件"
              placement="bottom"
              :open-delay="300"
            >
              <el-button
                class="btn_more"
                :class="{ activeUserMore: isMoreSearch }"
                size="small"
                icon="el-icon-d-arrow-right"
                @click="moreSearchBtn"
              ></el-button>
            </el-tooltip>
          </div>
          <div class="btnBox" v-else-if="cutDetail == 'QcCheckList'">
            <div class="searchBtnBox" v-if="isMoreSearch">
              <el-dropdown trigger="click" @command="QCOrderExport">
                <el-button class="downIcon" type="primary" icon="el-icon-d-arrow-right" size="small">导出</el-button>
                <el-dropdown-menu slot="dropdown" class="devicesDownloadDrop">
                  <el-dropdown-item command="检验单记录明细">检验单记录明细</el-dropdown-item>
                  <el-dropdown-item command="抽检SN记录明细">抽检SN记录明细</el-dropdown-item>
              </el-dropdown-menu>
              </el-dropdown>
              <el-tooltip
                class="item"
                content="清除查询条件"
                placement="bottom"
                :open-delay="300"
              >
                <el-button
                  icon="iconfont icon-qingkong"
                  size="small"
                  class="cleanBox"
                  @click="onClear"
                ></el-button>
              </el-tooltip>
              <el-button
                type="primary"
                icon="el-icon-search"
                size="small"
                @click="onSearch"
                >查询</el-button
              >
            </div>
            <el-tooltip
              class="item"
              content="查询条件"
              placement="bottom"
              :open-delay="300"
            >
              <el-button
                class="btn_more"
                :class="{ activeUserMore: isMoreSearch }"
                size="small"
                icon="el-icon-d-arrow-right"
                @click="moreSearchBtn"
              ></el-button>
            </el-tooltip>
          </div>
          <div class="btnBox" v-else-if="cutDetail == 'RepairRecordPage'">
            <div class="searchBtnBox" v-if="isMoreSearch">
              <el-button
                type="primary"
                icon="el-icon-download"
                size="small"
                @click="RepairRecordExport"
                >导出</el-button
              >
              <el-tooltip
                class="item"
                content="清除查询条件"
                placement="bottom"
                :open-delay="300"
              >
                <el-button
                  icon="iconfont icon-qingkong"
                  size="small"
                  class="cleanBox"
                  @click="onClear"
                ></el-button>
              </el-tooltip>
              <el-button
                type="primary"
                icon="el-icon-search"
                size="small"
                @click="onSearch"
                >查询</el-button
              >
            </div>
            <el-tooltip
              class="item"
              content="查询条件"
              placement="bottom"
              :open-delay="300"
            >
              <el-button
                class="btn_more"
                :class="{ activeUserMore: isMoreSearch }"
                size="small"
                icon="el-icon-d-arrow-right"
                @click="moreSearchBtn"
              ></el-button>
            </el-tooltip>
          </div>
          <div class="btnBox" v-else-if="cutDetail == 'proLog'">
            <div class="searchBtnBox" v-if="isMoreSearch">
              <el-button @click="onSearch(true)" class="downIcon" type="primary" size="small">导出</el-button>
              <el-tooltip class="item" content="清除查询条件" placement="bottom" :open-delay="300">
                <el-button icon="iconfont icon-qingkong" size="small" class="cleanBox" @click="onClear"></el-button>
              </el-tooltip>
              <el-button type="primary" icon="el-icon-search" size="small" @click="onSearch(false)">查询</el-button>
            </div>
            <el-tooltip
              class="item"
              content="查询条件"
              placement="bottom"
              :open-delay="300"
            >
              <el-button
                class="btn_more"
                :class="{ activeUserMore: isMoreSearch }"
                size="small"
                icon="el-icon-d-arrow-right"
                @click="moreSearchBtn"
              ></el-button>
            </el-tooltip>
          </div><div class="btnBox" v-else-if="cutDetail == 'uploadLog'">
            <div class="searchBtnBox" v-if="isMoreSearch">
              <el-tooltip class="item" content="清除查询条件" placement="bottom" :open-delay="300">
                <el-button icon="iconfont icon-qingkong" size="small" class="cleanBox" @click="onClear"></el-button>
              </el-tooltip>
              <el-button type="primary" icon="el-icon-search" size="small" @click="onSearch(false)">查询</el-button>
            </div>
            <el-tooltip
              class="item"
              content="查询条件"
              placement="bottom"
              :open-delay="300"
            >
              <el-button
                class="btn_more"
                :class="{ activeUserMore: isMoreSearch }"
                size="small"
                icon="el-icon-d-arrow-right"
                @click="moreSearchBtn"
              ></el-button>
            </el-tooltip>
          </div>
        </el-tab-pane>
      </el-tabs>
      <el-form
        :inline="true"
        :model="searchConditionForm"
        class="demo-form-inline"
        v-if="isMoreSearch && tabPaneValue == 'first'"
        key="first"
      >
        <div class="searchConditionBox" v-if="cutView" :key="1">
          <el-form-item label="组装单号" size="small">
            <el-input
              v-model="searchConditionForm.orderNumber"
              placeholder="组装工单号"
              clearable
              @keyup.enter.native="getProductionOrderSearch()"
            ></el-input>
          </el-form-item>
          <el-form-item label="SAP单号" size="small">
            <el-input
              v-model="searchConditionForm.sapOrderNumber"
              placeholder="SAP生产单号"
              clearable
              @keyup.enter.native="getProductionOrderSearch()"
            ></el-input>
          </el-form-item>
          <el-form-item label="裸机编码" size="small">
            <el-input
              v-model="searchConditionForm.itemCode"
              placeholder="裸机编码"
              clearable
              @keyup.enter.native="getProductionOrderSearch()"
            ></el-input>
          </el-form-item>
          <el-form-item label="产品类别" size="small">
            <el-select
              v-model="searchConditionForm.productType"
              placeholder="选择产品类别"
              filterable
              clearable
              @change="productTypeChange"
            >
              <el-option
                v-for="(item, index) in pullDownData.productTypeList"
                :key="index"
                :label="item.title"
                :value="item.code"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="产品型号" size="small">
            <el-select
              v-model="searchConditionForm.productId"
              placeholder="选择产品型号"
              filterable
              clearable
            >
              <el-option
                v-for="(item, index) in pullDownData.productList"
                :key="index"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="客户" size="small">
            <el-select
              v-model="searchConditionForm.customerId"
              placeholder="选择客户名称"
              filterable
              clearable
            >
              <el-option
                v-for="(item, index) in pullDownData.customerList"
                :key="index"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="销售订单" size="small">
            <el-input
              v-model="searchConditionForm.customerOrder"
              placeholder="销售订单号"
              clearable
              @keyup.enter.native="getProductionOrderSearch()"
            ></el-input>
          </el-form-item>
          <el-form-item label="下单时间" size="small">
            <el-date-picker
              v-model="searchConditionForm.startDateTime"
              type="date"
              placeholder="下单开始时间"
              value-format="yyyy-MM-dd"
              @change="startDateChange('searchConditionForm')"
              :picker-options="$store.state.pickerOptions"
            ></el-date-picker>
          </el-form-item>
          <el-form-item label="结束时间" size="small">
            <el-date-picker
              v-model="searchConditionForm.endDateTime"
              type="date"
              placeholder="下单结束时间"
              @change="endDateChange('searchConditionForm')"
              value-format="yyyy-MM-dd"
              :picker-options="$store.state.pickerOptions"
            ></el-date-picker>
          </el-form-item>
          <el-form-item label="工单状态" size="small">
            <el-select
              v-model="searchConditionForm.status"
              placeholder="选择工单状态"
              filterable
              clearable
              multiple
              collapse-tags
            >
              <el-option
                v-for="(item, index) in pullDownData.orderStatusList"
                :key="index"
                :label="item.title"
                :value="item.code"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="所有者" size="small">
            <el-select
              v-model="searchConditionForm.userId"
              placeholder="选择工单所有者"
              filterable
              clearable
              class="hiddenSelectDropdown"
              :popper-append-to-body="false"
              @visible-change="
                selectVisible($event, 'user', '员工选择', 'searchConditionForm')
              "
            >
              <el-option
                v-for="(item, index) in pullDownData.userList"
                :key="index"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
        </div>
        <div class="searchConditionBox" v-else-if="!cutView" :key="2">
          <el-form-item label="裸机编码" size="small">
            <el-input
              v-model="searchConditionForm.itemCode"
              placeholder="裸机编码"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item label="产品类别" size="small">
            <el-select
              v-model="searchConditionForm.productType"
              placeholder="选择产品类别"
              filterable
              clearable
              @change="productTypeChange"
            >
              <el-option
                v-for="(item, index) in pullDownData.productTypeList"
                :key="index"
                :label="item.title"
                :value="item.code"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="产品型号" size="small">
            <el-select
              v-model="searchConditionForm.productId"
              placeholder="选择产品型号"
              filterable
              clearable
            >
              <el-option
                v-for="(item, index) in pullDownData.productList"
                :key="index"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="客户" size="small">
            <el-select
              v-model="searchConditionForm.customerId"
              placeholder="选择客户名称"
              filterable
              clearable
            >
              <el-option
                v-for="(item, index) in pullDownData.customerList"
                :key="index"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="下单时间" size="small">
            <el-date-picker
              v-model="searchConditionForm.startDate"
              type="date"
              placeholder="下单开始时间"
              value-format="yyyy-MM-dd"
              @change="startDateChange('searchConditionForm')"
              :picker-options="$store.state.quickChecked"
            ></el-date-picker>
          </el-form-item>
          <el-form-item label="结束时间" size="small">
            <el-date-picker
              v-model="searchConditionForm.endDate"
              type="date"
              placeholder="下单结束时间"
              @change="endDateChange('searchConditionForm')"
              value-format="yyyy-MM-dd"
              :picker-options="$store.state.pickerOptions"
            ></el-date-picker>
          </el-form-item>
        </div>
      </el-form>
      <el-form
        :inline="true"
        :model="devicesSearchForm"
        class="demo-form-inline"
        v-else-if="
          isMoreSearch && tabPaneValue != 'first' && cutDetail == 'devices'
        "
        key="devices"
      >
        <div class="searchConditionBox">
          <el-form-item label="SN" size="small">
            <el-input
              v-model="devicesSearchForm.sn"
              placeholder="SN"
              clearable
              @keyup.enter.native="$refs.devicesPage.getProductionOrderDevices()"
            ></el-input>
          </el-form-item>
          <el-form-item label="PCBA" size="small">
            <el-input
              v-model="devicesSearchForm.pcba"
              placeholder="PCBA"
              clearable
              @keyup.enter.native="$refs.devicesPage.getProductionOrderDevices()"
            ></el-input>
          </el-form-item>
          <el-form-item label="MAC" size="small">
            <el-input
              v-model="devicesSearchForm.mac"
              placeholder="无线、有线、蓝牙等"
              clearable
              @keyup.enter.native="$refs.devicesPage.getProductionOrderDevices()"
            ></el-input>
          </el-form-item>
          <el-form-item label="UUID" size="small">
            <el-input
              v-model="devicesSearchForm.uuid"
              placeholder="UUID"
              clearable
              @keyup.enter.native="$refs.devicesPage.getProductionOrderDevices()"
            ></el-input>
          </el-form-item>
          <el-form-item label="IMEI/ICCID" size="small">
            <el-input
              v-model="devicesSearchForm.imei"
              placeholder="IMEI或ICCID"
              clearable
              @keyup.enter.native="$refs.devicesPage.getProductionOrderDevices()"
            ></el-input>
          </el-form-item>
          <el-form-item label="其它SN" size="small">
            <el-input
              v-model="devicesSearchForm.otherSn"
              placeholder="配件、说明书等"
              clearable
              @keyup.enter.native="$refs.devicesPage.getProductionOrderDevices()"
            ></el-input>
          </el-form-item>
          <el-form-item label="当前工序" size="small">
            <el-select
              v-model="devicesSearchForm.workStationId"
              placeholder="设备所在的工序"
              multiple
              collapse-tags
              filterable
              clearable
              @change="workStationChange"
            >
              <el-option
                v-for="(item, index) in pullDownData.productionOrderStatusList"
                :key="index"
                :label="item.workStation.name"
                :value="item.workStation.id"
              ></el-option>
            </el-select>
          </el-form-item>
        </div>
      </el-form>
      <el-form
        :inline="true"
        :model="partListForm"
        class="demo-form-inline"
        v-else-if="
          isMoreSearch && tabPaneValue != 'first' && cutDetail == 'partList'
        "
        key="partList"
      >
        <div class="searchConditionBox">
          <el-form-item label="配件SN" size="small">
            <el-input
              v-model="partListForm.sn"
              placeholder="输入配件SN"
              clearable
              @keyup.enter.native="$refs.partListPage.getProOrderPartList()"
            ></el-input>
          </el-form-item>
          <el-form-item label="配件名" size="small">
            <el-select
              v-model="partListForm.partName"
              placeholder="选择配件名称"
              filterable
              clearable
            >
              <el-option label="4G配件" value="FourthG"></el-option>
              <el-option label="左耳" value="Left"></el-option>
              <el-option label="右耳" value="Right"></el-option>
              <el-option label="电池仓" value="ChargingCase"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="零件" size="small">
            <el-select
              v-model="partListForm.partType"
              placeholder="选择测试对象类别"
              filterable
              clearable
            >
              <el-option label="主板" value="PCBA"></el-option>
              <el-option label="电池" value="Battery"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="产品SN" size="small">
            <el-input
              v-model="partListForm.deviceSn"
              placeholder="输入产品SN"
              clearable
              @keyup.enter.native="$refs.partListPage.getProOrderPartList()"
            ></el-input>
          </el-form-item>
        </div>
      </el-form>
      <el-form
        :inline="true"
        :model="QCReportForm"
        class="demo-form-inline"
        v-else-if="
          isMoreSearch && tabPaneValue != 'first' && cutDetail == 'QCReport'
        "
        key="QCReport"
      >
        <div class="searchConditionBox">
          <el-form-item label="SN" size="small">
            <el-input
              v-model="QCReportForm.sn"
              placeholder="SN"
              clearable
              @keyup.enter.native="$refs.QCReportPage.getProOrderQCReport()"
            ></el-input>
          </el-form-item>
          <el-form-item label="工序" size="small">
            <el-select v-model="QCReportForm.workStationId" placeholder="选择工序"
              filterable clearable multiple collapse-tags>
              <el-option
                v-for="(item, index) in pullDownData.productSopList"
                :key="index"
                :label="item.title"
                :value="item.workStation.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="测试类型" size="small">
            <el-select
              v-model="QCReportForm.type"
              placeholder="选择测试类型"
              filterable
              clearable
            >
              <el-option
                v-for="(item, index) in pullDownData.QCTypeList"
                :key="index"
                :label="item.title"
                :value="item.code"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="测试对象" size="small">
            <el-select
              v-model="QCReportForm.targetType"
              placeholder="选择测试对象"
              filterable
              clearable
            >
              <el-option
                v-for="(item, index) in pullDownData.QCTargetTypeList"
                :key="index"
                :label="item.title"
                :value="item.code"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="员工" size="small">
            <el-select
              v-model="QCReportForm.userId"
              placeholder="选择员工"
              filterable
              clearable
              class="hiddenSelectDropdown"
              :popper-append-to-body="false"
              @visible-change="
                selectVisible($event, 'user', '员工选择', 'QCReportForm')
              "
            >
              <el-option
                v-for="(item, index) in pullDownData.userList"
                :key="index"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="错误代码" size="small">
            <el-select
              v-model="QCReportForm.code"
              filterable
              allow-create
              default-first-option
              placeholder="错误代码"
              clearable
            >
              <el-option label="所有错误" value="-99998"> </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="开始时间" size="small">
            <el-date-picker
              v-model="QCReportForm.startDateTime"
              type="datetime"
              placeholder="开始时间"
              value-format="yyyy-MM-dd HH:mm:ss"
              clearable
              @change="startDateTimeChange('QCReportForm')"
              :picker-options="$store.state.pickerOptions"
            ></el-date-picker>
          </el-form-item>
          <el-form-item label="结束时间" size="small">
            <el-date-picker
              v-model="QCReportForm.endDateTime"
              type="datetime"
              placeholder="结束时间"
              value-format="yyyy-MM-dd HH:mm:ss"
              clearable
              @change="endDateTimeChange('QCReportForm')"
              :picker-options="$store.state.pickerOptions"
            ></el-date-picker>
          </el-form-item>
        </div>
      </el-form>
      <el-form
        :inline="true"
        :model="inspectionForm"
        class="demo-form-inline"
        v-else-if="
          isMoreSearch && tabPaneValue != 'first' && cutDetail == 'QcCheckList'
        "
        key="inspections"
      >
        <div class="searchConditionBox">
          <el-form-item label="检验单号" size="small">
            <el-input v-model="inspectionForm.orderNumber" placeholder="送检单号" clearable
              @keyup.enter.native="getQcCheckListSearch()" />
          </el-form-item>
          <el-form-item label="抽检批次" size="small">
            <el-input v-model="inspectionForm.partLot" placeholder="抽检批次" clearable
              @keyup.enter.native="getQcCheckListSearch()" />
          </el-form-item>
          <el-form-item label="送检时间" size="small">
            <el-date-picker
              v-model="inspectionForm.startDateTime"
              type="datetime"
              placeholder="送检开始时间"
              value-format="yyyy-MM-dd HH:mm:ss"
              @change="startDateChange('searchConditionForm')"
              :picker-options="$store.state.pickerOptions"
            ></el-date-picker>
          </el-form-item>
          <el-form-item label="结束时间" size="small">
            <el-date-picker
              v-model="inspectionForm.endDateTime"
              type="datetime"
              placeholder="送检结束时间"
              @change="endDateChange('searchConditionForm')"
              value-format="yyyy-MM-dd HH:mm:ss"
              :picker-options="$store.state.pickerOptions"
            ></el-date-picker>
          </el-form-item>
          <el-form-item label="客户" size="small">
            <el-select
              v-model="inspectionForm.customerId"
              placeholder="选择客户名称"
              filterable
              clearable
            >
              <el-option
                v-for="(item, index) in pullDownData.customerList"
                :key="index"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="所有者" size="small">
            <el-select
              v-model="inspectionForm.userId"
              placeholder="选择工单所有者"
              filterable
              clearable
              class="hiddenSelectDropdown"
              :popper-append-to-body="false"
              @visible-change="
                selectVisible($event, 'user', '员工选择', 'inspectionForm')
              "
            >
              <el-option
                v-for="(item, index) in pullDownData.userList"
                :key="index"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
        </div>
      </el-form>
      <!--维修记录查询条件-->
      <el-form
        :inline="true"
        :model="RepairRecordForm"
        class="demo-form-inline"
        v-else-if="
          isMoreSearch && tabPaneValue != 'first' && cutDetail == 'RepairRecordPage'
        "
        key="RepairRecordPages"
      >
        <div class="searchConditionBox" v-if="tabPaneData.product && (tabPaneData.product.productType.code=='AI_PC' || tabPaneData.product.productType.code=='AI_SERVER')">
          <el-form-item label="SN" size="small">
            <el-input v-model="RepairRecordForm.key" placeholder="内部SN或客户SN" clearable
              @keyup.enter.native="onSearch()" />
          </el-form-item>
          <el-form-item label="不良代码" size="small">
            <el-input v-model="RepairRecordForm.errorCode1" placeholder="不良代码" clearable
              @keyup.enter.native="onSearch()" />
          </el-form-item>
          <el-form-item label="原因代码" size="small">
            <el-input v-model="RepairRecordForm.errorCode2" placeholder="原因代码" clearable
              @keyup.enter.native="onSearch()" />
          </el-form-item>
          <el-form-item label="权责代码" size="small">
            <el-input v-model="RepairRecordForm.errorCode3" placeholder="权责代码" clearable
              @keyup.enter.native="onSearch()" />
          </el-form-item>
          <el-form-item label="维修方式" size="small">
            <el-input v-model="RepairRecordForm.errorCode4" placeholder="维修方式" clearable
              @keyup.enter.native="onSearch()" />
          </el-form-item>
          <el-form-item label="维修状态" size="small">
          <el-select v-model="RepairRecordForm.status" filterable multiple allow-create default-first-option placeholder="维修状态" clearable>
            <el-option label="待送修" value="WAIT_REPAIR"> </el-option>
            <el-option label="待维修" value="WAIT"> </el-option>
            <el-option label="维修中" value="REPAIRING"> </el-option>
            <el-option label="维修完成" value="COMPLETED"> </el-option>
            <el-option label="维修失败" value="FAIL"> </el-option>
            <el-option label="退回送修前" value="ROLLBACK"> </el-option>
          </el-select>
          </el-form-item>          
        </div>
        <div v-else>
          <el-form-item label="SN" size="small">
            <el-input v-model="RepairRecordForm.sn" placeholder="SN或MAC" clearable
              @keyup.enter.native="getQcCheckListSearch()" />
          </el-form-item>          
          <el-form-item label="维修开始" size="small">
            <el-date-picker
              v-model="RepairRecordForm.startDateTime"
              type="datetime"
              placeholder="维修开始时间"
              value-format="yyyy-MM-dd HH:mm:ss"
              @change="startDateChange('searchConditionForm')"
              :picker-options="$store.state.pickerOptions"
            ></el-date-picker>
          </el-form-item>
          <el-form-item label="维修结束" size="small">
            <el-date-picker
              v-model="RepairRecordForm.endDateTime"
              type="datetime"
              placeholder="维修结束时间"
              @change="endDateChange('searchConditionForm')"
              value-format="yyyy-MM-dd HH:mm:ss"
              :picker-options="$store.state.pickerOptions"
            ></el-date-picker>
          </el-form-item>
        </div>
      </el-form>
      <el-form :inline="true" :model="proLogForm" class="demo-form-inline"
        v-else-if="isMoreSearch && tabPaneValue != 'first' && cutDetail == 'proLog'" key="proLog">
        <div class="searchConditionBox">
          <el-form-item label="请求ID" size="small">
            <el-input
              :value="proLogForm.id"
              @input="idInputChange($event, 'proLogForm')"
              placeholder="Request ID"
              clearable
              @keyup.enter.native="$refs.ProLogPage.getFactoryLogSearch()"
            ></el-input>
          </el-form-item>
          <el-form-item label="Key" size="small">
            <el-input
              v-model="proLogForm.key"
              placeholder="输入Key"
              clearable
              @keyup.enter.native="$refs.ProLogPage.getFactoryLogSearch()"
            ></el-input>
          </el-form-item>
          <el-form-item label="员工" size="small">
            <el-select
              v-model="proLogForm.userId"
              placeholder="选择员工"
              filterable
              clearable
              class="hiddenSelectDropdown"
              :popper-append-to-body="false"
              @visible-change="
                selectVisible($event, 'user', '员工选择', 'proLogForm')
              "
            >
              <el-option
                v-for="(item, index) in pullDownData.userList"
                :key="index"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="线体" size="small">
            <el-cascader
              :options="pullDownData.factoryOrgData"
              :props="{
                checkStrictly: true,
                emitPath: false,
                label: 'name',
                value: 'id',
              }"
              :show-all-levels="false"
              v-model="proLogForm.organizationId"
              @change="cascaderChange($event, 'factoryOrgCascader')"
              ref="factoryOrgCascader"
              placeholder="选择所在线体"
              clearable
            ></el-cascader>
          </el-form-item>
          <el-form-item label="工序" size="small">
            <el-select v-model="proLogForm.workStationId" placeholder="选择工序"
              filterable clearable multiple collapse-tags>
              <el-option
                v-for="(item, index) in pullDownData.productSopList"
                :key="index"
                :label="item.title"
                :value="item.workStation.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="错误代码" size="small">
            <!-- <el-input
              v-model="proLogForm.errorCode"
              placeholder="错误代码"
              clearable
            ></el-input> -->
            <el-select
              v-model="proLogForm.errorCode"
              filterable
              allow-create
              default-first-option
              placeholder="错误代码"
              clearable
            >
              <el-option label="所有错误" value="-99998"> </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="开始时间" size="small">
            <el-date-picker
              v-model="proLogForm.startDateTime"
              type="datetime"
              placeholder="开始时间"
              value-format="yyyy-MM-dd HH:mm:ss"
              clearable
              @change="startDateChange('proLogForm')"
              :picker-options="$store.state.pickerOptions"
            ></el-date-picker>
          </el-form-item>
          <el-form-item label="结束时间" size="small">
            <el-date-picker
              v-model="proLogForm.endDateTime"
              type="datetime"
              placeholder="结束时间"
              value-format="yyyy-MM-dd HH:mm:ss"
              clearable
              @change="endDateChange('proLogForm')"
              :picker-options="$store.state.pickerOptions"
            ></el-date-picker>
          </el-form-item>
        </div>
      </el-form>
      <el-form :inline="true" :model="uploadLogForm" class="demo-form-inline"
        v-else-if="isMoreSearch && tabPaneValue != 'first' && cutDetail == 'uploadLog'" key="uploadLog">
        <div class="searchConditionBox">
          <el-form-item label="RequestId" size="small">
            <el-input
              v-model="uploadLogForm.requestId"
              placeholder="输入RequestId"
              clearable
              @keyup.enter.native="$refs.UploadLogPage.getUploadLogSearch()"
            ></el-input>
          </el-form-item>
          <el-form-item label="SN" size="small">
            <el-input
              v-model="uploadLogForm.sn"
              placeholder="输入SN"
              clearable
              @keyup.enter.native="$refs.UploadLogPage.getUploadLogSearch()"
            ></el-input>
          </el-form-item>
          <el-form-item label="Action" size="small">
            <el-input
              v-model="uploadLogForm.action"
              placeholder="输入Action"
              clearable
              @keyup.enter.native="$refs.UploadLogPage.getUploadLogSearch()"
            ></el-input>
          </el-form-item>
          <el-form-item label="Type" size="small">
            <el-input
              v-model="uploadLogForm.type"
              placeholder="输入测试类型"
              clearable
              @keyup.enter.native="$refs.UploadLogPage.getUploadLogSearch()"
            ></el-input>
          </el-form-item>
          <el-form-item label="错误代码" size="small">
            <el-select
              v-model="uploadLogForm.errorCode"
              filterable
              allow-create
              default-first-option
              placeholder="错误代码"
              clearable
            >
              <el-option label="所有错误" value="-99998"> </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="开始时间" size="small">
            <el-date-picker
              v-model="uploadLogForm.startDateTime"
              type="datetime"
              placeholder="开始时间"
              value-format="yyyy-MM-dd HH:mm:ss"
              clearable
              @change="startDateChange('uploadLogForm')"
              :picker-options="$store.state.pickerOptions"
            ></el-date-picker>
          </el-form-item>
          <el-form-item label="结束时间" size="small">
            <el-date-picker
              v-model="uploadLogForm.endDateTime"
              type="datetime"
              placeholder="结束时间"
              value-format="yyyy-MM-dd HH:mm:ss"
              clearable
              @change="endDateChange('uploadLogForm')"
              :picker-options="$store.state.pickerOptions"
            ></el-date-picker>
          </el-form-item>
        </div>
      </el-form>
      <div
        class="tips tipsBox"
        v-show="tabPaneValue != 'first' && cutDetail == 'process' && isShowTips"
      >
        <span class="title">温馨提示：</span>
        <span class="text"
          >如果出现“模版缺失”请确认标签模版中是否有产品型号对应的模版，并检查组装工单的【裸机编码】是否正确。</span
        >
        <i class="el-icon-close close" @click="closeTips"></i>
      </div>
    </div>
    <div class="contentBox" v-if="tabPaneValue == 'first'">
      <div class="rightContent">
        <div class="chartView" v-if="!cutView" :key="1">
          <div class="echartBtn">
            <el-button
              :type="echartType == '柱状图' ? 'primary' : ''"
              size="small"
              @click="echartCutBtn('柱状图')"
              >柱状图</el-button
            >
            <el-button
              :type="echartType == '饼图' ? 'primary' : ''"
              size="small"
              @click="echartCutBtn('饼图')"
              >饼图</el-button
            >
          </div>
          <div class="myEchart" ref="myEchart"></div>
        </div>
        <div class="tableView" v-else :key="2">
          <el-table
            stripe
            :data="tableData"
            border
            style="width: 100%"
            height="100%"
            size="mini"
            @sort-change="sortChange"
          >
            <el-table-column
              type="index"
              :width="pagination.endIndex >= 1000 ? 80 : 50"
              align="center"
              :index="pagination.beginIndex"
            ></el-table-column>
            <el-table-column prop="orderNumber" label="组装单号" min-width="120px" sortable="custom" align="center">
              <template slot-scope="scope">
                <el-tooltip class="item" effect="dark" :content="'ID: '+scope.row.id" placement="top" :open-delay="300">
                  <span class="textOverflow allowSkip" @click="clickAllowSkip(scope.row)">{{scope.row.orderNumber}}</span>
                </el-tooltip>
              </template>
            </el-table-column>
            <el-table-column min-width="125px"
              prop="sapOrderNum" label="SAP单号" align="center" show-overflow-tooltip>
              <template slot-scope="scope">
                <span v-if="scope.row.sapOrderNumber">{{ scope.row.sapOrderNumber }}</span>
                <span v-else>-</span>
              </template>
            </el-table-column>
            <el-table-column
              min-width="125px"
              prop="itemCode"
              label="裸机编码"
              align="center"
              show-overflow-tooltip
            >
              <template slot-scope="scope">
                <span v-if="scope.row.itemCode">{{ scope.row.itemCode }}</span>
                <span v-else>-</span>
              </template>
            </el-table-column>
            <el-table-column
              prop="productId"
              label="产品型号"
              min-width="95px"
              align="center"
              show-overflow-tooltip
            >
              <template slot-scope="scope">
                <span v-if="scope.row.product">{{
                  scope.row.product.code
                }}</span>
              </template>
            </el-table-column>
            <el-table-column
              prop="customerId"
              label="客户"
              min-width="120px"
              align="center"
              show-overflow-tooltip
            >
              <template slot-scope="scope">
                <span v-if="scope.row.customer">{{
                  scope.row.customer.name
                }}</span>
              </template>
            </el-table-column>
            <el-table-column
              prop="quantity"
              sortable="custom"
              label="数量"
              width="90px"
              align="center"
              show-overflow-tooltip
            ></el-table-column>
            <el-table-column align="center" max-width="90px" show-overflow-tooltip
              label="已测数量" prop="testQuantity">
            </el-table-column>
            <el-table-column align="center" max-width="90px" show-overflow-tooltip
              label="直通率" prop="rty">
            </el-table-column>
            <el-table-column
              prop="planFinishDate"
              label="计划交货时间"
              min-width="135px"
              align="center"
              sortable="custom"
            >
            <template slot-scope="scope">
              <span v-if="scope.row.status.code=='READY' || !scope.row.planFinishDate">-</span>
              <el-tooltip v-else-if="scope.row.planTimeOut"
                class="item expire"
                effect="dark"
                :content="'已逾期【'+(-scope.row.planTimeOut) +' 天】未交货！'"
                placement="top"
                :open-delay="300"
              >
                <span class="textOverflow">
                  <i class="iconfont icon-yiguoqi"></i>{{ scope.row.planFinishDate }}
                </span>
              </el-tooltip>
              <el-tooltip v-else class="item" effect="dark" placement="top" :open-delay="300"
                :content="scope.row.planFinishDate">
                <div class="textOverflow">{{ scope.row.planFinishDate }}</div>
              </el-tooltip>
            </template>
            </el-table-column>
            <el-table-column prop="startDate" label="开始/结单时间" min-width="115px" align="center">
              <template slot-scope="scope">
                <span v-if="scope.row.status.code=='READY' || !scope.row.startDateTime">-</span>
                <el-tooltip v-else class="item" effect="dark" placement="top" :open-delay="300"
                  :content="(scope.row.startDateTime ? ('【开始生产：'+ scope.row.startDateTime)+'】':'') + (scope.row.closedDate ? ('【结单：' + scope.row.closedDate+'】') : '')">
                  <div class="textOverflow" v-if="scope.row.closedDate">{{ scope.row.closedDate }}</div>
                  <div class="textOverflow" v-else-if="scope.row.startDateTime">{{ scope.row.startDateTime }}</div>
                </el-tooltip>
              </template>
            </el-table-column>
          <el-table-column prop="createUser"
            min-width="95px" label="所有者" align="center" show-overflow-tooltip>
            <template slot-scope="scope">
              <span v-if="scope.row.createUser">
                {{ scope.row.createUser.name }} ({{ scope.row.createUser.employeeNum }})
              </span>
              <span v-else>-</span>
            </template>
          </el-table-column>
          <el-table-column class-name="operation" label="状态" align="center"
            width="95px"
            prop="status"
            sortable="custom">
            <template slot-scope="scope">
              <el-tooltip v-if="scope.row.timeOut  && scope.row.timeOut>0"
                class="item expire"
                effect="dark"
                :content="'已逾期【'+scope.row.timeOut +' 天】未关闭工单，请及时关闭工单！'"
                placement="top"
                :open-delay="300"
              >
                <span class="textOverflow">
                  <i class="iconfont icon-yiguoqi"></i>{{ scope.row.status.title }}
                </span>
              </el-tooltip>
              <el-tooltip v-else class="item" effect="dark" placement="top" :open-delay="300"
                :content="scope.row.status.title">
                <span class="textOverflow">{{ scope.row.status.title }}</span>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column class-name="operation" width="95px" label="操作" align="center">
            <template slot-scope="scope">
              <el-tooltip
                v-if="scope.row.status && scope.row.status.code=='PRODUCTION'"
                class="item"
                effect="dark"
                content="暂停"
                placement="top"
                :open-delay="300"
              >
                <i @click="pauseOrder($event, scope.row)" class="iconfont icon-pause"></i>
              </el-tooltip>
              <el-tooltip
                v-if="scope.row.status && scope.row.status.code!='LOCKED'&& scope.row.status.code!='CLOSED'"
                class="item"
                effect="dark"
                content="锁定"
                placement="top"
                :open-delay="300"
              >
                <i @click="lockOrder($event, scope.row)" class="el-icon-lock"></i>
              </el-tooltip>
              <el-tooltip
                v-else-if="scope.row.status && scope.row.status.code=='LOCKED'"
                class="item"
                effect="dark"
                content="解锁"
                placement="top"
                :open-delay="300"
              >
                <i @click="unlockOrder($event, scope.row)" class="el-icon-unlock"></i>
              </el-tooltip>
              <el-tooltip
                v-else-if="scope.row.status && scope.row.status.code=='CLOSED'"
                class="item"
                effect="dark"
                content="重新打开"
                placement="top"
                :open-delay="300"
              >
                <i @click="reopenOrder($event, scope.row)" class="iconfont icon-chongqi"></i>
              </el-tooltip>
              <el-tooltip
                v-if="scope.row.status && scope.row.status.code!='CLOSED'"
                class="item"
                effect="dark"
                content="交接"
                placement="top"
                :open-delay="300"
              >
                <i
                  @click="handover($event, scope.row)"
                  class="iconfont icon-jiaojie"
                ></i>
              </el-tooltip>
            </template>
          </el-table-column>
          </el-table>
          <pagination
            :pagination="pagination"
            @currentChange="currentChange"
            @sizeChange="sizeChange"
            @refreshBtn="getProductionOrderSearch"
          ></pagination>
        </div>
      </div>
    </div>
    <div class="contentBox" v-else>
      <div class="rightContent" v-if="cutDetail != 'process'">
        <detailPage
          ref="detailPage"
          v-if="cutDetail == 'detail'"
          :tabPaneValue="tabPaneValue"
        ></detailPage>
        <devicesPage
          ref="devicesPage"
          v-else-if="cutDetail == 'devices'"
          :tabPaneValue="tabPaneValue"
          :devicesSearchForm="devicesSearchForm"
        ></devicesPage>
        <partListPage
          ref="partListPage"
          v-else-if="cutDetail == 'partList'"
          :tabPaneValue="tabPaneValue"
          :partListForm="partListForm"
        ></partListPage>
        <div class="chartView" v-else-if="cutDetail == 'status'">
          <div class="echartBtn">
            <el-button style="min-width: 100px"
              :type="proStatus == '产品状态' ? 'primary' : ''" size="small" @click="cutProStatus('产品状态')">
              产品状态
            </el-button>
            <el-button style="min-width: 100px"
              :type="proStatus == '投产报表' ? 'primary' : ''" size="small" @click="cutProStatus('投产报表')">
              投产报表
            </el-button>
            <el-button v-if="tabPaneData.product.hasPart" style="min-width: 100px"
              :type="proStatus == '配件状态' ? 'primary' : ''" size="small" @click="cutProStatus('配件状态')">
              配件状态
            </el-button>
            <el-button style="min-width: 100px"
              :type="proStatus == '异常统计' ? 'primary' : ''" size="small" @click="cutProStatus('异常统计')">
              异常统计
            </el-button>
            <el-button style="min-width: 100px"
              :type="proStatus == 'Top10日报' ? 'primary' : ''" size="small" @click="cutProStatus('Top10日报')">
              Top10日报
            </el-button>
            <el-button style="min-width: 100px"
              :type="proStatus == 'Top10时报' ? 'primary' : ''" size="small" @click="cutProStatus('Top10时报')">
              Top10时报
            </el-button>
            <el-button style="min-width: 100px"
              :type="proStatus == '维修Top5日报' ? 'primary' : ''" size="small" @click="cutProStatus('维修Top5日报')">
              维修Top5日报
            </el-button>
          </div>
          <div v-if="proStatus == '产品状态'"
            class="statusEchart" ref="statusEchart" key="statusEchart">
          </div>
          <div v-if="proStatus == '投产报表'"
            class="status2Echart" ref="status2Echart" key="status2Echart">
          </div>
          <div v-else-if="proStatus == '配件状态'"
            class="partEchart" ref="partEchart" key="partEchart">
          </div>
          <div v-if="proStatus == '异常统计'" id="exceptionEchartDiv"
            class="exceptionEchart" ref="exceptionEchart" key="exceptionEchart">
          </div>
          <div v-if="proStatus == 'Top10日报'" id="anomalyReportByDaysDiv"
            class="anomalyReportByDays" ref="anomalyReportByDays" key="anomalyReportByDays">
          </div>
          <div v-if="proStatus == 'Top10时报'" id="anomalyReportByHoursDiv"
            class="anomalyReportByHours" ref="anomalyReportByHours" key="anomalyReportByHours">
          </div>
          <div v-if="proStatus == '维修Top5日报'" id="repairReportByDaysDiv"
            class="repairReportByDays" ref="repairReportByDays" key="repairReportByDays">
          </div>
        </div>
        <QCReportPage
          ref="QCReportPage"
          v-else-if="cutDetail == 'QCReport'"
          :tabPaneValue="tabPaneValue"
          :QCReportForm="QCReportForm"
        ></QCReportPage>
        <RepairRecordPage
          ref="RepairRecordPage"
          v-else-if="cutDetail == 'RepairRecordPage'"
          :tabPaneValue="tabPaneValue"
          :tabPaneData="tabPaneData"
          :RepairRecordForm="RepairRecordForm"
        ></RepairRecordPage>
         <QcCheckListPage
          ref="QcCheckListPage"
          v-else-if="cutDetail == 'QcCheckList'"
          :tabPaneValue="tabPaneValue"
          :inspectionForm="inspectionForm"
        ></QcCheckListPage>
        <ProLogPage
          ref="ProLogPage"
          v-else-if="cutDetail == 'proLog'"
          :tabPaneValue="tabPaneValue"
          :proLogForm="proLogForm"
        ></ProLogPage>
        <UploadLogPage
          ref="UploadLogPage"
          v-else-if="cutDetail == 'uploadLog'"
          :tabPaneValue="tabPaneValue"
          :uploadLogForm="uploadLogForm"
        ></UploadLogPage>
      </div>
      <processPage
        ref="processPage"
        v-else-if="cutDetail == 'process'"
        :tabPaneValue="tabPaneValue"
      ></processPage>
    </div>
    <myDialog
      ref="myDialog"
      :title="dialogTitle"
      @submitData="submitData"
      @dialogClose="dialogClose"
      width="450px"
    >
      <template slot="content">
        <el-form
          ref="dialogForm"
          :model="HandoverForm"
          :rules="dialogRules"
          :label-width="labelWidth"
        >
          <div v-if="dialogTitle == '开始生产【'+this.tabPaneData.orderNumber+'】'">
            <el-form-item label="交货日期：" size="small" prop="dateTime">
              <el-date-picker
                v-model="HandoverForm.date"
                type="date"
                placeholder="计划交货时间"
                value-format="yyyy-MM-dd"
                clearable
                :picker-options="$store.state.pickerOptions"
              ></el-date-picker>
            </el-form-item>
          </div>
          <div v-else-if="dialogTitle == '设置成【烧录完成】待OTA'">
            <el-form-item label="要OTA的工序" size="small">
              <el-select
              v-model="HandoverForm.workStationId"
              placeholder="设备所在的工序"
              multiple
              collapse-tags
              filterable
              clearable
              >
              <el-option
                v-for="(item, index) in pullDownData.productionOrderStatusList2"
                :key="index"
                :label="item.workStation.name"
                :value="item.workStation.id"
              ></el-option>
              </el-select>
            </el-form-item>
          </div>
          <div v-else-if="dialogTitle == '按当前工序锁定产品'">
            <el-form-item label="要锁定的工序" size="small">
              <el-select
              v-model="HandoverForm.workStationId"
              placeholder="设备所在的工序"
              multiple
              collapse-tags
              filterable
              clearable
              >
              <el-option
                v-for="(item, index) in pullDownData.productionOrderStatusList2"
                :key="index"
                :label="item.workStation.name"
                :value="item.workStation.id"
              ></el-option>
              </el-select>
            </el-form-item>
          </div>
          <div v-else-if="dialogTitle == '交接组装工单'" key="pe">
            <el-form-item
              label="新所有者："
              size="small"
              prop="userId"
            >
            <el-select
              v-model="HandoverForm.userId"
              placeholder="选择新所有者"
              filterable
              clearable
              class="hiddenSelectDropdown"
              :popper-append-to-body="false"
              @visible-change="
                selectVisible($event, 'user', '员工选择', 'HandoverForm')
              "
            >
              <el-option
                v-for="(item, index) in pullDownData.userList"
                :key="index"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
            </el-form-item>
          </div>
        </el-form>
      </template>
    </myDialog>
    <orderTableSelect
      ref="orderTableSelect"
      @orderTableSubmit="orderTableSubmit"
    ></orderTableSelect>
  </div>
</template>

<script>
import pagination from "@/components/pagination.vue";
import * as echarts from "echarts";
import { apiUploadFile, apiUploadDolder } from "@/api/filesUpload.js";
import detailPage from "./components/detailPage.vue";
import devicesPage from "./components/devicesPage.vue";
import partListPage from "./components/partListPage.vue";
import processPage from "./components/processPage.vue";
import QCReportPage from "./components/QCReportPage.vue";
import RepairRecordPage from "./components/RepairRecordPage.vue";
import QcCheckListPage from "./components/QcCheckListPage.vue";
import ProLogPage from "./components/logsPage.vue";
import UploadLogPage from "./components/uploadLogPage.vue";
import orderTableSelect from "@/components/orderTableSelect.vue";
import myDialog from "@/components/myDialog.vue";
import {
  apiProductionOrderSearch,
  apiProductionOrderStart,
  apiProductionOrderClose,
  apiProductionOrderCountByStatus,
  apiCustomerList,
  apiProductTypeList,
  apiProductList,
  apiOrderStatusList,
  apiProductionOrderStatusList,
  apiProductionOrderStatusList2,
  apiProductionOrderBindFid,
  apiProductionOrderDeviceStatus,
  apiProductionOrderDeviceStatus2,
  apiProOrderDevicePart,
  apiWorkStationList,
  apiQCTypeList,
  apiQCTargetTypeList,
  apiProductSopList,
  apiResetErrorDevice,
  apiUnLockDevice,
  apiResetUnpacked,
  apiProductionOrderPause,
  apiProductionOrderLock,
  apiHandoverOrder,
  apiProductionOrderLockDevice2,
  apiProductionOrderOtaDevice,
  apiProductionOrderUnlock,
  apiProductionOrderReopen
} from "@/api/productionOrder.js";
import { apiFactoryOrgShow } from "@/api/productSystem.js";
import { apiAnomalyReport, apiAnomalyReportByDays, apiAnomalyReportByHours} from "@/api/qcRecord.js";
import { apiRepairReportByDays} from "@/api/repair.js";
export default {
  lastModuleConfig: { modulePath: "/homePage/productionOrder", subTabs: { cutView: [true, false] } },
  components: {
    pagination,
    detailPage,
    devicesPage,
    partListPage,
    processPage,
    myDialog,
    QCReportPage,
    RepairRecordPage,
    ProLogPage,
    UploadLogPage,
    orderTableSelect,
    QcCheckListPage,
  },
  computed: {
    // 详情状态按钮
    detailStatusText() {
      const { code } = this.detailStatus;
      if (this.$refs.detailPage) {
        switch (code) {
          case "READY":
            return "开始生产";
          case "PRODUCTION":
            return "结单";
          default:
            return "";
        }
      } else {
        return "";
      }
    },
    // 是否显示导入SN/UUID按钮（通用条件）
    showImportSnUuidBtn() {
      const product = this.tabPaneData.product || {};
      const isNotAIProduct = product.productType?.code !== 'AI_PC' && product.productType?.code !== 'AI_SERVER';
      const canImportSn = this.tabPaneData.snFid === "0" && (this.tabPaneData.importSn || product.importSn);
      const isNotD070 = product.code !== 'D070';
      const isD051 = product.code === 'D051';
      const isNotSpecialP2P = !product.p2pType ||
        (product.p2pType.code !== 'OWLET' &&
         !(product.p2pType.code === 'QiHu360' || product.p2pType.code === 'QiHu360_4G') &&
         product.p2pType.code !== 'LinkView' && product.p2pType.code !== 'LinkViewByWakeUp');
      // 广联智通有专属导入按钮（导入Excel/导入Zip），不显示通用按钮
      const isNotGuanLian = !(this.tabPaneData.customer && this.tabPaneData.customer.id == '215434450273710080');
      
      return isNotAIProduct && isNotGuanLian && (isD051 || (canImportSn && isNotD070 && isNotSpecialP2P));
    },
    // 是否显示导入SN/UUID按钮（LinkView特殊条件）
    showLinkViewImportBtn() {
      const product = this.tabPaneData.product || {};
      const isLinkView = product.p2pType && 
        (product.p2pType.code === 'LinkView' || product.p2pType.code === 'LinkViewByWakeUp');
      
      return isLinkView && product.importSn && this.tabPaneData.snFid === '0';
    },
    // 是否显示导入UUID按钮（D070 WuXiao条件）
    showD070UuidImportBtn() {
      const product = this.tabPaneData.product || {};
      const isD070WuXiao = product.code === 'D070' && 
        product.p2pType && 
        product.p2pType.code === 'WuXiao';
      
      return isD070WuXiao && this.tabPaneData.uuidFid === 0;
    },
  },
  data() {
    return {
      dialogForm: {},
      dialogTitle: "",
      dialogRules: {
        userId: [
          { required: true, message: "工单的新所有者不能为空！", trigger: "change" },
        ],
        date: [
          {
            required: true,
            message: "交货日期不能为空！",
            trigger: "change",
          },
        ],
      },
      productSopData: null,
      textvalue: "",
      tabPaneList: [],
      tabPaneValue: "first",
      tabPaneData: {},
      isMoreSearch: false,
      searchConditionForm: {},
      detailData: {},
      detailStatus: {}, // 详情状态
      devicesSearchForm: {},
      uploadType: "file",
      partListForm: {},
      QCReportForm: {},
      RepairRecordForm:{},
      HandoverForm: {},
      inspectionForm:{},
      proLogForm: {},
      uploadLogForm: {},
      isShowTips: true,
      pullDownData: {
        customerList: [],
        productTypeList: [],
        productList: [],
        orderStatusList: [],
        productionOrderStatusList: [],
        productionOrderStatusList2: [],
        workStationList: [],
        QCTypeList: [],
        QCTargetTypeList: [],
        factoryOrgData: [],
        productSopList: [],
        userList: [], // 员工列表
      },
      cutView: true,
      echartType: "柱状图",
      proStatus: "产品状态",
      cutDetail: "detail",
      tableData: [],
      desc: undefined,
      orderBy: [],
      pagination: {
        currentPage: 1,
        pageSize: 40,
        total: 102,
        beginIndex: 1,
        endIndex: 10,
      },
      labelWidth: this.$store.state.labelWidth,
      nowRowData: {},
      currentProcessKey: "",
    };
  },
  watch: {
    tabPaneValue: function (newVal) {
      this.$moreSearchStyle();
      if (newVal == "first") {
        if (this.cutView) {
          this.getProductionOrderSearch();
        } else {
          this.getProductionOrderCountByStatus();
        }
      } else {
        this.$nextTick(() => {
          this.tabPaneList.forEach((item) => {
            if (item.id == newVal) {
              this.tabPaneData = item;
            }
          });
          if (this.cutDetail == "detail") {
            this.$refs.detailPage.getProductionOrderDetail();
            
          } else if (this.cutDetail == "devices") {
            this.$set(this.devicesSearchForm, "workStationId", undefined);
            this.$refs.devicesPage.pagination.currentPage = 1;
            this.$refs.devicesPage.getProductionOrderDevices(
              "",
              this.getProductionOrderStatusList
            );
          } else if (this.cutDetail == "partList") {
            this.$refs.partListPage.getProOrderPartList();
          } else if (this.cutDetail == "status") {
            this.cutProStatus(this.proStatus);
          } else if (this.cutDetail == "process") {
            this.$refs.processPage.currentProcessKey = this.currentProcessKey;
            this.$refs.processPage.getProductionLineData();
            this.$refs.processPage.getProductSopSearch();
          } else if (this.cutDetail == "QCReport") {
            this.$refs.QCReportPage.getProOrderQCReport();
            this.getProductSopList();
          } else if (this.cutDetail == "proLog") {
            this.$set(this.proLogForm, "workStationId", undefined);
            this.$refs.ProLogPage.getFactoryLogSearch("", false, this.getProductSopList);
          }  else if (this.cutDetail == "uploadLog") {
            this.$refs.UploadLogPage.getUploadLogSearch("");
          } else if (this.cutDetail == "QcCheckList") {
            this.$refs.QcCheckListPage.getQcCheckListSearch();
          }
          else if (this.cutDetail == "RepairRecordPage") {
            this.$refs.RepairRecordPage.getRepairSearch();
          }
        });
      }
    },
  },
  methods: {
    async otaByStatus() {
      const res = await apiProductionOrderStatusList2({
        all: false,
        id: this.tabPaneValue,
      });
      if (res.code == 0) {
        this.pullDownData.productionOrderStatusList2 = res.data;
        this.dialogTitle = "设置成【烧录完成】待OTA";
        this.$refs.myDialog.dialogVisible = true;
      }
    },
    async lockByStatus() {
      const res = await apiProductionOrderStatusList2({
        all: false,
        id: this.tabPaneValue,
      });
      if (res.code == 0) {
        this.pullDownData.productionOrderStatusList2 = res.data;
        this.dialogTitle = "按当前工序锁定产品";
        this.$refs.myDialog.dialogVisible = true;
      }
    },
    // 交接工单
    handover(e, row) {
      this.dialogTitle = "交接组装工单";
      this.$refs.myDialog.dialogVisible = true;
      this.HandoverForm = {
        id: row.id
      };
    },
    startProduction(row) {
      this.dialogTitle = "开始生产【"+row.orderNumber+"】";
      this.$refs.myDialog.dialogVisible = true;
      this.HandoverForm = {
        id: row.id
      };
    },
    // 对话框提交
    submitData(title) {
      this.$refs.dialogForm.validate(async (valid) => {
        if (valid) {
          let res = {};
          if (title == "交接组装工单") {
            res = await apiHandoverOrder({
              ...this.HandoverForm
            });
            if (res.code == 0) {
              this.$refs.myDialog.dialogVisible = false;
              this.getProductionOrderSearch();
              this.$message({
                message: "工单所有者交接成功",
                type: "success",
              });
            }
          } else if(title=='开始生产【'+this.tabPaneData.orderNumber+'】') {
            let res = {};
            res = await apiProductionOrderStart({
              ...this.HandoverForm
            });
            if (res.code == 0) {
              this.$refs.detailPage.getProductionOrderDetail();
              this.$refs.myDialog.dialogVisible = false;
              this.getProductionOrderSearch();
              this.$message({
                message: res.msg,
                type: "success",
              });
            }
          } else if(title=='按当前工序锁定产品') {
            res = await apiProductionOrderLockDevice2({
              id: this.tabPaneValue,
              workStationId : this.HandoverForm.workStationId
            });
            if (res.code == 0) {
              this.$refs.myDialog.dialogVisible = false;
              this.getProOrderDeviceStatus(this.callback);

              this.$message({
                message: res.msg,
                type: "success",
              });
            }
          } else if(title=='设置成【烧录完成】待OTA') {
            res = await apiProductionOrderOtaDevice({
              id: this.tabPaneValue,
              workStationId : this.HandoverForm.workStationId
            });
            if (res.code == 0) {
              this.$refs.myDialog.dialogVisible = false;
              this.getProOrderDeviceStatus(this.callback);

              this.$message({
                message: res.msg,
                type: "success",
              });
            }
          }
        } else {
          return false;
        }
      });
    },
    // 关闭对话框
    dialogClose() {
      this.$refs.dialogForm.resetFields();
      this.dialogForm = {};
      this.HandoverForm = {};
    },
    pauseOrder(e, row, src) {
      e.target.blur();
      const h = this.$createElement;
      this.$msgbox({
        title: `警告：暂停后产线将暂时不能生产此工单！`,
        message: h("div", null, [
          h(
            "span",
            null,
            `请输入工单号:【`
          ),
          h("i", { style: "color: var(--themeColor)" }, row.orderNumber),
          h("span", null, `】以确认锁定！`),
        ]),
        showCancelButton: true,
        confirmButtonText: `确认`,
        cancelButtonText: "取消",
        closeOnClickModal: false,
        showInput: true,
        beforeClose: (action, instance, done) => {
          if (action === "confirm") {
            if (instance.inputValue == row.orderNumber) {
              done();
            } else {
              this.$message({
                type: "warning",
                message: `输入错误，请重新输入或取消！`,
              });
            }
          } else {
            done();
          }
        },
      }).then(async () => {
        const res = await apiProductionOrderPause({
          orderId: row.id
        });
        if (res.code == 0) {
          if (src) {
            this.$refs.detailPage.getProductionOrderDetail();
          } else {
            this.pagination.currentPage = 1;
            this.getProductionOrderSearch();
          }
          this.$message({
            type: "success",
            message: res.msg
          });
        }
      });
    },
    // 锁定工单
    lockOrder(e, row) {
      e.target.blur();
      const h = this.$createElement;
      this.$msgbox({
        title: `警告：锁定后不能继续生产！`,
        message: h("div", null, [
          h(
            "span",
            null,
            `请输入工单号:【`
          ),
          h("i", { style: "color: var(--themeColor)" }, row.orderNumber),
          h("span", null, `】以确认锁定！`),
        ]),
        showCancelButton: true,
        confirmButtonText: `确认`,
        cancelButtonText: "取消",
        closeOnClickModal: false,
        showInput: true,
        beforeClose: (action, instance, done) => {
          if (action === "confirm") {
            if (instance.inputValue == row.orderNumber) {
              done();
            } else {
              this.$message({
                type: "warning",
                message: `输入错误，请重新输入或取消！`,
              });
            }
          } else {
            done();
          }
        },
      }).then(async () => {
        const res = await apiProductionOrderLock({
          orderId: row.id
        });
        if (res.code == 0) {
          this.pagination.currentPage = 1;
          this.getProductionOrderSearch();
          this.$message({
            type: "success",
            message: "组装工单锁定成功，该工单将暂停生产！"
          });
        }
      });
    },
    // 重新打开工单
    reopenOrder(e, row) {
      e.target.blur();
      const h = this.$createElement;
      this.$msgbox({
        title: `提示：重新将工单设置为“待生产”状态！`,
        message: h("div", null, [
          h(
            "span",
            null,
            `请输入工单号:【`
          ),
          h("i", { style: "color: var(--themeColor)" }, row.orderNumber),
          h("span", null, `】以确认重新打开工单！`),
        ]),
        showCancelButton: true,
        confirmButtonText: `确认`,
        cancelButtonText: "取消",
        closeOnClickModal: false,
        showInput: true,
        beforeClose: (action, instance, done) => {
          if (action === "confirm") {
            if (instance.inputValue == row.orderNumber) {
              done();
            } else {
              this.$message({
                type: "warning",
                message: `输入错误，请重新输入或取消！`,
              });
            }
          } else {
            done();
          }
        },
      }).then(async () => {
        const res = await apiProductionOrderReopen({
          id: row.id,
          orderType: 0
        });
        if (res.code == 0) {
          this.pagination.currentPage = 1;
          this.getProductionOrderSearch();
          this.$message({
            type: "success",
            message: "组装工单重新打开成功！"
          });
        }
      });
    },
    // 解锁工单
    unlockOrder(e, row) {
      e.target.blur();
      const h = this.$createElement;
      this.$msgbox({
        title: `温馨提示：解锁后需要重新开始生产！`,
        message: h("div", null, [
          h(
            "span",
            null,
            `请输入工单号:【`
          ),
          h("i", { style: "color: var(--themeColor)" }, row.orderNumber),
          h("span", null, `】以确认解锁！`),
        ]),
        showCancelButton: true,
        confirmButtonText: `确认`,
        cancelButtonText: "取消",
        closeOnClickModal: false,
        showInput: true,
        beforeClose: (action, instance, done) => {
          if (action === "confirm") {
            if (instance.inputValue == row.orderNumber) {
              done();
            } else {
              this.$message({
                type: "warning",
                message: `输入错误，请重新输入或取消！`,
              });
            }
          } else {
            done();
          }
        },
      }).then(async () => {
        const res = await apiProductionOrderUnlock({
          orderId: row.id,
          orderType: 0
        });
        if (res.code == 0) {
          this.pagination.currentPage = 1;
          this.getProductionOrderSearch();
          this.$message({
            type: "success",
            message: "组装工单解锁成功，请重新【开始生产】！"
          });
        }
      });
    },
    // 切换一级面板
    tabPaneClick(tab) {
      this.tabPaneValue = tab.name;
    },
    // 关闭一级面板
    closeTabPane(index) {
      if (this.tabPaneList[index].id == this.tabPaneValue) {
        if (index > 0) {
          this.tabPaneValue = this.tabPaneList[index - 1].id;
        } else {
          this.tabPaneValue = "first";
        }
      }
      this.tabPaneList.splice(index, 1);
    },
    // 组装工单-切换视图
    cutViewChange(value) {
      this.cutView = value;
      if (value) {
        this.getProductionOrderSearch();
      } else {
        this.getProductionOrderCountByStatus();
      }
      this.$moreSearchStyle();
    },
    // 图表视图-切换图表类型
    echartCutBtn(type) {
      this.echartType = type;
      this.getProductionOrderCountByStatus();
    },
    // 切换详情-二级面板
    cutDetailChange(value) {
      this.cutDetail = value;
      this.$moreSearchStyle();
      this.$nextTick(() => {
        if (value == "detail") {
          this.$refs.detailPage.getProductionOrderDetail();
        } else if (value == "devices") {
          this.$refs.devicesPage.getProductionOrderDevices(
            "",
            this.getProductionOrderStatusList
          );
        } else if (value == "partList") {
          this.$refs.partListPage.getProOrderPartList();
        } else if (this.cutDetail == "status") {
          this.cutProStatus(this.proStatus);
        } else if (value == "process") {
          this.$refs.processPage.currentProcessKey = this.currentProcessKey;
          this.$refs.processPage.getProductionLineData();
          this.$refs.processPage.getProductSopSearch();
        } else if (this.cutDetail == "QCReport") {
          this.$refs.QCReportPage.getProOrderQCReport();          
            this.getProductSopList();
        } else if (this.cutDetail == "proLog") {
          this.$refs.ProLogPage.getFactoryLogSearch("", false, this.getProductSopList);
        }  else if (this.cutDetail == "uploadLog") {
          this.$refs.UploadLogPage.getUploadLogSearch("");
        } else if (this.cutDetail == "QcCheckList") {
          this.$refs.QcCheckListPage.getQcCheckListSearch();
        }else if (this.cutDetail == "RepairRecordPage") {
          this.$refs.RepairRecordPage.getRepairSearch();
        }
      });
    },
    // 表格数据
    async getProductionOrderSearch(remove, callback) {
      if (!(remove == "noRemove")) {
        this.tableData = [];
      }
      const res = await apiProductionOrderSearch({
        ...this.searchConditionForm,
        pageNum: this.pagination.currentPage,
        pageSize: this.pagination.pageSize,
        desc: this.desc,
        orderBy: this.orderBy,
      });
      // console.log(res);
      if (res.code == 0) {
        this.tableData = res.data;
        this.pagination.total = res.total;
        this.pagination.beginIndex = res.beginIndex;
        this.pagination.endIndex = res.endIndex;
        if (callback) callback();
      }
    },
    // 开始生产
    startProduction1(row, msg = `现在开始生产：${row.orderNumber} ？`, force) {
      this.$confirm(msg, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(async () => {
        const res = await apiProductionOrderStart({
          id: row.id,
          force,
        });
        if (res.code == 0) {
          if (this.tabPaneValue == "first") {
            this.getProductionOrderSearch("noRemove");
          } else if (this.cutDetail != "status") {
            this.$refs.detailPage.getProductionOrderDetail();
          }
          this.$message({
            type: "success",
            message: "开始成功",
          });
        } else if (res.code == 1024) {
          setTimeout(() => {
            this.startProduction(row, res.msg, true);
          }, 300);
        }
      });
    },
    // 结单生产
    closeProduction(row, msg = `确认结单：${row.orderNumber} ？`, force) {
      this.$confirm(msg, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(async () => {
        const res = await apiProductionOrderClose({
          id: row.id,
          force,
        });
        if (res.code == 0) {
          if (this.tabPaneValue == "first") {
            this.getProductionOrderSearch("noRemove");
          } else if (this.cutDetail != "status") {
            this.$refs.detailPage.getProductionOrderDetail();
          }
          this.$message({
            type: "success",
            message: "结单成功",
          });
        } else if (res.code == 1024) {
          setTimeout(() => {
            this.closeProduction(row, res.msg, true);
          }, 300);
        }
      });
    },
    resetUnpacked() {
      const h = this.$createElement;
      this.$msgbox({
        title: `重置未包装的产品`,
        message: h("div", null, [
          h(
            "span",
            null,
            `请输入工单号:【`
          ),
          h("i", { style: "color: var(--themeColor)" }, this.tabPaneData.orderNumber),
          h("span", null, `】以便将未包装的产品重置回【待生产】状态`),
        ]),
        showCancelButton: true,
        confirmButtonText: `确认`,
        cancelButtonText: "取消",
        closeOnClickModal: false,
        showInput: true,
        beforeClose: (action, instance, done) => {
          if (action === "confirm") {
            if (instance.inputValue == this.tabPaneData.orderNumber) {
              done();
            } else {
              this.$message({
                type: "warning",
                message: `输入错误，请重新输入或取消！`,
              });
            }
          } else {
            done();
          }
        },
      }).then(async () => {
        const res = await apiResetUnpacked({
          id: this.tabPaneValue
        });
        if (res.code == 0) {
          if (this.proStatus == "产品状态") {
            this.getProOrderDeviceStatus(this.callback);
          } else if (this.proStatus == "配件状态") {
            this.getProOrderDevicePart(this.callback);
          }
          this.$message({
            message: res.msg,
            type: "success",
          });
        }
      });
    },
    unLock() {
      const h = this.$createElement;
      this.$msgbox({
        title: `解锁异常锁定的产品`,
        message: h("div", null, [
          h(
            "span",
            null,
            `请输入工单号:【`
          ),
          h("i", { style: "color: var(--themeColor)" }, this.tabPaneData.orderNumber),
          h("span", null, `】以便确认解锁异常锁定的产品`),
        ]),
        showCancelButton: true,
        confirmButtonText: `确认`,
        cancelButtonText: "取消",
        closeOnClickModal: false,
        showInput: true,
        beforeClose: (action, instance, done) => {
          if (action === "confirm") {
            if (instance.inputValue == this.tabPaneData.orderNumber) {
              done();
            } else {
              this.$message({
                type: "warning",
                message: `输入错误，请重新输入或取消！`,
              });
            }
          } else {
            done();
          }
        },
      }).then(async () => {
        const res = await apiUnLockDevice({
          id: this.tabPaneValue
        });
        if (res.code == 0) {
          if (this.proStatus == "产品状态") {
            this.getProOrderDeviceStatus(this.callback);
          } else if (this.proStatus == "配件状态") {
            this.getProOrderDevicePart(this.callback);
          }
          this.$message({
            message: res.msg,
            type: "success",
          });
        }
      });
    },
    resetError() {
      const h = this.$createElement;
      this.$msgbox({
        title: `注意：仅能释放5分钟及更早前烧录失败的SN`,
        message: h("div", null, [
          h(
            "span",
            null,
            `请输入工单号:【`
          ),
          h("i", { style: "color: var(--themeColor)" }, this.tabPaneData.orderNumber),
          h("span", null, `】以便确认释放烧录失败的SN`),
        ]),
        showCancelButton: true,
        confirmButtonText: `确认`,
        cancelButtonText: "取消",
        closeOnClickModal: false,
        showInput: true,
        beforeClose: (action, instance, done) => {
          if (action === "confirm") {
            if (instance.inputValue == this.tabPaneData.orderNumber) {
              done();
            } else {
              this.$message({
                type: "warning",
                message: `输入错误，请重新输入或取消！`,
              });
            }
          } else {
            done();
          }
        },
      }).then(async () => {
        const res = await apiResetErrorDevice({
          id: this.tabPaneValue
        });
        if (res.code == 0) {
          if (this.proStatus == "产品状态") {
            this.getProOrderDeviceStatus(this.callback);
          } else if (this.proStatus == "配件状态") {
            this.getProOrderDevicePart(this.callback);
          }
          this.$message({
            message: res.msg,
            type: "success",
          });
        }
      });
      // if (this.detailStatus.code == "READY") {
      //   this.startProduction(this.tabPaneData);
      // } else if (this.detailStatus.code == "PRODUCTION") {
      //   this.closeProduction(this.tabPaneData);
      // }
    },
    // 工单详情--详情状态按钮
    detailStatusBtn() {
      if (this.detailStatus.code == "READY") {
        this.startProduction(this.tabPaneData);
      } else if (this.detailStatus.code == "PRODUCTION") {
        this.closeProduction(this.tabPaneData);
      }
    },
    // 图表数据
    async getProductionOrderCountByStatus(callback) {
      const res = await apiProductionOrderCountByStatus({
        ...this.searchConditionForm,
        orderNumber: undefined,
        customerOrder: undefined,
        status: undefined,
      });
      // console.log(res);
      if (res.code == 0) {
        let myEchart = echarts.init(this.$refs.myEchart);
        myEchart.clear();
        if (!res.data.length) {
          this.$message({
            type: "warning",
            message: "查询数据为空",
          });
        }
        let option = {};
        if (this.echartType == "柱状图") {
          let nameList = [],
            countList = [],
            allCount = 0;
          res.data.forEach((item) => {
            nameList.unshift(item.status);
            countList.unshift(item.count);
            allCount += item.count;
          });
          option = {
            backgroundColor: "#fff",
            title: {
              text: "订单总数：" + allCount,
              left: "center",
              textStyle: {
                color: "#303133",
              },
            },
            xAxis: {
              type: "category",
              data: nameList,
              axisLine: {
                lineStyle: {
                  color: "#303133",
                },
              },
              axisTick: {
                alignWithLabel: true,
              },
            },
            yAxis: {
              type: "value",
              splitLine: {
                lineStyle: {
                  type: "dashed",
                },
              },
              axisLine: {
                lineStyle: {
                  color: "#303133",
                },
              },
            },
            tooltip: {
              show: true,
              trigger: "axis",
              axisPointer: {
                // 坐标轴指示器，坐标轴触发有效
                type: "shadow", // 默认为直线，可选为：'line' | 'shadow'
              },
            },
            series: [
              {
                data: countList,
                type: "bar",
                barWidth: 80,
              },
            ],
            // backgroundColor: "#333",
          };
        } else if (this.echartType == "饼图") {
          let allCount = 0,
            legendData = [],
            seriesData = [];
          res.data.forEach((item) => {
            allCount += item.count;
            legendData.unshift(item.status + "：" + item.count);
            seriesData.unshift({
              value: item.count,
              name: item.status + "：" + item.count,
              tooltip: {
                formatter: "{a}<br />{b}：{d}%",
              },
            });
          });
          option = {
            color: [
              "#dd6b66",
              "#759aa0",
              "#e69d87",
              "#d48265",
              "#91c7ae",
              "#749f83",
              "#ca8622",
              "#bda29a",
              "#6e7074",
              "#546570",
              "#c4ccd3",
            ],
            title: {
              text: "订单总数：" + allCount,
              left: "center",
              textStyle: {
                color: "#303133",
              },
            },
            tooltip: {
              trigger: "item",
              formatter: "{a} <br/>{b} : {c} ({d}%)",
            },
            legend: {
              orient: "vertical",
              left: "left",
              top: 30,
              data: legendData,
              textStyle: {
                color: "#303133",
              },
            },
            series: [
              {
                name: "状态",
                type: "pie",
                radius: "55%",
                center: ["50%", "60%"],
                data: seriesData,
                label: {
                  color: "rgba(0, 0, 0)",
                },
                emphasis: {
                  itemStyle: {
                    shadowBlur: 10,
                    shadowOffsetX: 0,
                    shadowColor: "rgba(0, 0, 0, 0.5)",
                  },
                },
              },
            ],
            // backgroundColor: "#333",
          };
        }
        myEchart.setOption(option);
        if (callback) callback();
      }
    },
    // 生产状态--切换图表
    cutProStatus(value, callback) {
      this.proStatus = value;
      if (value == "产品状态") {
        this.getProOrderDeviceStatus(callback);
      } else if (value == "投产报表") {
        this.getProOrderDeviceStatus2(callback);
      } else if (value == "配件状态") {
        this.getProOrderDevicePart(callback);
      } else if (value == "异常统计") {
        this.getAnomalyReport(callback);
      } else if (value == "Top10日报") {
        this.getAnomalyReportByDays(callback);
      } else if (value == "Top10时报") {
        this.getAnomalyReportByHours(callback);
      } else if (value == "维修Top5日报") {
        this.getRepairReportByDays(callback);
      }
      
    },
    // 产品状态
    async getProOrderDeviceStatus2(callback) {
      const res = await apiProductionOrderDeviceStatus2({
        id: this.tabPaneValue,
      });
      // console.log(res);
      if (res.code == 0) {
        let myEchart = echarts.init(this.$refs.status2Echart);
        myEchart.clear();
        if (!res.data.length) {
          this.$message({
            type: "warning",
            message: "查询数据为空",
          });
        }
        let option = {};
        let nameList = [],
          countList = [];
        res.data.forEach((item) => {
          nameList.push(item.workstation);
          countList.push(item.qty);
        });
        option = {
          backgroundColor: "#fff",
          title: {
            text: "投产报表",
            left: "center",
            textStyle: {
              color: "#303133",
            },
          },
          xAxis: {
            type: "category",
            data: nameList
          },
          yAxis: {
            type: "value"
          },
          tooltip: {
            show: true,
            trigger: "axis",
            axisPointer: {
              // 坐标轴指示器，坐标轴触发有效
              type: "shadow", // 默认为直线，可选为：'line' | 'shadow'
            },
          },
          series: [
            {
              data: countList,
              type: "line"
            },
          ],
          // backgroundColor: "#333",
        };
        myEchart.setOption(option);
        if (callback) callback();
      }
    },
    // 产品状态
    async getProOrderDeviceStatus(callback) {
      const res = await apiProductionOrderDeviceStatus({
        id: this.tabPaneValue,
      });
      // console.log(res);
      if (res.code == 0) {
        let allCount = 0;
        res.data.forEach((item) => (allCount += item.count));
        let legendData = res.data.map(
          (item) => item.workStation.name + "：" + item.count + "PCS"
        );
        let seriesData = res.data.map((item) => {
          return {
            value: item.count,
            name: item.workStation.name + "：" + item.count + "PCS",
            tooltip: {
              formatter: "{a}<br />{b}：{d}%",
            },
          };
        });
        let myEchart = echarts.init(this.$refs.statusEchart);
        myEchart.clear();
        let option = {
          backgroundColor: "#fff",
          color: [
            "#dd6b66",
            "#759aa0",
            "#e69d87",
            "#d48265",
            "#91c7ae",
            "#749f83",
            "#ca8622",
            "#bda29a",
            "#6e7074",
            "#546570",
            "#c4ccd3",
          ],
          title: {
            text: "裸机数量：" + allCount,
            left: "center",
            textStyle: {
              color: "#303133",
            },
          },
          tooltip: {
            trigger: "item",
            formatter: "{a} <br/>{b} : {c} ({d}%)",
          },
          legend: {
            orient: "vertical",
            left: "left",
            top: 30,
            data: legendData,
            textStyle: {
              color: "#303133",
            },
          },
          series: [
            {
              name: "状态",
              type: "pie",
              radius: "55%",
              center: ["50%", "60%"],
              data: seriesData,
              label: {
                color: "rgba(0, 0, 0)",
              },
              emphasis: {
                itemStyle: {
                  shadowBlur: 10,
                  shadowOffsetX: 0,
                  shadowColor: "rgba(0, 0, 0, 0.5)",
                },
              },
            },
          ],
          // backgroundColor: "rgba(0, 0, 0, 0.5)",
        };
        myEchart.setOption(option);
        if (callback) callback();
      }
    },
    async getAnomalyReportByDays(callback) {
      const res = await apiAnomalyReportByDays({
        id: this.tabPaneValue
      });
      if (res.code == 0) {
        if (!res.data || !res.data.series || res.data.series.length==0) {
          this.$message({
            type: "warning",
            message: "查询数据为空",
          });
        }
        let anomalyReportByDays = echarts.init(this.$refs.anomalyReportByDays);
        anomalyReportByDays.clear();
        let option = {
          backgroundColor: "#fff",
          title: {
            left: "center",
            text: '异常Top10日曲线'
          },
          tooltip: {
            trigger: 'axis',
            axisPointer: {
              type: 'shadow'
            }
          },
          legend: {
            top: 30,
            data: res.data.legend
          },
          grid: {
            top: 100,
            left: '3%',
            right: '4%',
            bottom: '3%',
            containLabel: true
          },
          xAxis: {
            type: 'category',
            boundaryGap: false,
            data: res.data.xAxis
          },
          yAxis: {
            type: 'value'
          },
          series: res.data.series
        };
        anomalyReportByDays.setOption(option);
        if (callback) callback();
      }
    },
    async getAnomalyReportByHours(callback) {
      const res = await apiAnomalyReportByHours({
        id: this.tabPaneValue
      });
      if (res.code == 0) {
        if (!res.data || !res.data.series || res.data.series.length==0) {
          this.$message({
            type: "warning",
            message: "查询数据为空",
          });
        }
        let anomalyReportByHours = echarts.init(this.$refs.anomalyReportByHours);
        anomalyReportByHours.clear();
        let option = {
          backgroundColor: "#fff",
          title: {
            left: "center",
            text: '异常Top10两小时曲线'
          },
          tooltip: {
            trigger: 'axis',
            axisPointer: {
              type: 'shadow'
            }
          },
          legend: {
            top: 30,
            data: res.data.legend
          },
          grid: {
            top: 100,
            left: '3%',
            right: '4%',
            bottom: '3%',
            containLabel: true
          },
          xAxis: {
            type: 'category',
            boundaryGap: false,
            data: res.data.xAxis
          },
          yAxis: {
            type: 'value'
          },
          series: res.data.series
        };
        anomalyReportByHours.setOption(option);
        if (callback) callback();
      }
    },
    async getAnomalyReport(callback) {
      const res = await apiAnomalyReport({
        id: this.tabPaneValue
      });
      if (res.code == 0) {
        if (!res.data || res.data.series.length==0) {
          this.$message({
            type: "warning",
            message: "查询数据为空",
          });
        }
        let exceptionEchart = echarts.init(this.$refs.exceptionEchart);
        exceptionEchart.clear();
        exceptionEchart.resize({height:res.data.yAxis.data.length*42 + 80});
        let option = {
          backgroundColor: "#fff",
          title: {
            left: "center",
            text: '异常排行'
          },
          tooltip: {
            trigger: 'axis',
            axisPointer: {
              type: 'shadow'
            }
          },
          legend: {},
          grid: {
            left: '3%',
            right: '4%',
            bottom: '3%',
            containLabel: true
          },
          xAxis: {
            type: "value"
          },
          yAxis: res.data.yAxis,
          series: res.data.series,
          // backgroundColor: "#333",
        };
        exceptionEchart.setOption(option);
        if (callback) callback();
        exceptionEchart.on('click',  function(param) {
            //param.name x轴值,param.data y轴值
            alert(param.name+":"+param.data)
        });
      }
    },
    async getRepairReportByDays(callback) {
      const res = await apiRepairReportByDays({
        id: this.tabPaneValue
      });
      if (res.code == 0) {
        if (!res.data || !res.data.series || res.data.series.length==0) {
          this.$message({
            type: "warning",
            message: "查询数据为空",
          });
        }
        let repairReportByDays = echarts.init(this.$refs.repairReportByDays);
        repairReportByDays.clear();
        let option = {
          backgroundColor: "#fff",
          title: {
            left: "center",
            text: ''
          },
          tooltip: {
            trigger: 'axis',
            axisPointer: {
              type: 'shadow'
            }
          },
          legend: {},
          grid: {
            top: 120,
            left: '3%',
            right: '4%',
            bottom: '3%',
            containLabel: true
          },
          yAxis: {
            type: 'category',
            boundaryGap: true,
            data: res.data.xAxis
          },
          xAxis: {
            type: 'value'
          },
          series: res.data.series
        };
        repairReportByDays.setOption(option);
        if (callback) callback();
      }
    },
    // 配件状态
    async getProOrderDevicePart(callback) {
      const res = await apiProOrderDevicePart({
        id: this.tabPaneValue,
      });
      if (res.code == 0) {
        let partEchart = echarts.init(this.$refs.partEchart);
        partEchart.clear();
        if (!res.data.length) {
          this.$message({
            type: "warning",
            message: "查询数据为空",
          });
        }
        let option = {};
        let nameList = [],
          countList = [];
        res.data.forEach((item) => {
          nameList.unshift(item.name);
          countList.unshift(item.count);
        });
        option = {
          backgroundColor: "#fff",
          xAxis: {
            type: "category",
            data: nameList,
            axisLine: {
              lineStyle: {
                color: "#303133",
              },
            },
            axisTick: {
              alignWithLabel: true,
            },
          },
          yAxis: {
            type: "value",
            splitLine: {
              lineStyle: {
                type: "dashed",
              },
            },
            axisLine: {
              lineStyle: {
                color: "#303133",
              },
            },
          },
          tooltip: {
            show: true,
            trigger: "axis",
            axisPointer: {
              // 坐标轴指示器，坐标轴触发有效
              type: "shadow", // 默认为直线，可选为：'line' | 'shadow'
            },
          },
          series: [
            {
              data: countList,
              type: "bar",
              barWidth: 80,
            },
          ],
          // backgroundColor: "#333",
        };
        partEchart.setOption(option);
        if (callback) callback();
      }
    },
    // 更多查询
    moreSearchBtn() {
      this.isMoreSearch = !this.isMoreSearch;
      this.$moreSearchStyle();
    },
    onlyMyChange() {
        this.getProductionOrderSearch();
    },
    //批量异常锁定
    batchLockDevice() {
      this.$refs.devicesPage.batchLockDevice();
    },
    //批量解锁异常
    batchUnLockDevice() {
      this.$refs.devicesPage.batchUnLockDevice();
    },
    // 清除查询
    onClear() {
      if (this.tabPaneValue == "first") {
        this.searchConditionForm = {};
        this.pagination.currentPage = 1;
        if (this.cutView) {
          this.getProductionOrderSearch();
        } else {
          this.getProductionOrderCountByStatus();
        }
      } else {
        if (this.cutDetail == "devices") {
          this.devicesSearchForm = {};
          this.$refs.devicesPage.pagination.currentPage = 1;
          // props传参数据有延迟，需要nextTick延迟调用数据
          this.$nextTick(() => {
            this.$refs.devicesPage.getProductionOrderDevices();
            this.$moreSearchStyle(); // 当前工序多选撑开高度
          });
        } else if (this.cutDetail == "partList") {
          this.partListForm = {};
          this.$refs.partListPage.pagination.currentPage = 1;
          this.$nextTick(() => {
            this.$refs.partListPage.getProOrderPartList();
          });
        } else if (this.cutDetail == "QCReport") {
          this.QCReportForm = {};
          this.$refs.QCReportPage.pagination.currentPage = 1;
          this.$nextTick(() => {
            this.$refs.QCReportPage.getProOrderQCReport();
          });
        } else if (this.cutDetail == "proLog") {
          this.proLogForm = {};
          this.$refs.ProLogPage.pagination.currentPage = 1;
          this.$nextTick(() => {
            this.$refs.ProLogPage.getFactoryLogSearch();
          });
        }  else if (this.cutDetail == "uploadLog") {
          this.uploadLogForm = {};
          this.$refs.UploadLogPage.pagination.currentPage = 1;
          this.$nextTick(() => {
            this.$refs.UploadLogPage.getUploadLogSearch();
          });
        } else if (this.cutDetail == "QcCheckList") {
          this.inspectionForm={};
          this.$refs.QcCheckListPage.pagination.currentPage=1;
          this.$nextTick(() => {
           this.$refs.QcCheckListPage.getQcCheckListSearch();
          });
          
        }else if (this.cutDetail == "RepairRecordPage") {
          this.RepairRecordForm={};
          this.$refs.RepairRecordPage.pagination.currentPage=1;
          this.$nextTick(() => {
           this.$refs.RepairRecordPage.getRepairSearch();
          });
          
        }
      }
    },
    // 确认查询
    onSearch(value) {
      if (this.tabPaneValue == "first") {
        this.pagination.currentPage = 1;
        if (this.cutView) {
          this.getProductionOrderSearch();
        } else {
          this.getProductionOrderCountByStatus();
        }
      } else {
        if (this.cutDetail == "devices") {
          this.devicesSearchForm.like = value;
          this.$refs.devicesPage.pagination.currentPage = 1;
          this.$refs.devicesPage.getProductionOrderDevices();
        } else if (this.cutDetail == "partList") {
          this.partListForm.like = value;
          this.$refs.partListPage.pagination.currentPage = 1;
          this.$refs.partListPage.getProOrderPartList();
        } else if (this.cutDetail == "QCReport") {
          this.$refs.QCReportPage.pagination.currentPage = 1;
          this.$refs.QCReportPage.getProOrderQCReport();
        } else if (this.cutDetail == "proLog") {
          this.$refs.ProLogPage.pagination.currentPage = 1;
          this.$refs.ProLogPage.getFactoryLogSearch(value ? "noRemove" : "", value);
        } else if (this.cutDetail == "uploadLog") {
          this.$refs.UploadLogPage.pagination.currentPage = 1;
          this.$refs.UploadLogPage.getUploadLogSearch(value ? "noRemove" : "", value);
        } else if (this.cutDetail == "QcCheckList") {
          this.$refs.QcCheckListPage.pagination.currentPage = 1;
          this.$refs.QcCheckListPage.getQcCheckListSearch();
        } else if (this.cutDetail == "RepairRecordPage") {
          this.$refs.RepairRecordPage.pagination.currentPage = 1;
          this.$refs.RepairRecordPage.getRepairSearch();
        }
      }
    },
    // 产品列表表格导出
    tableExport(command) {
      this.$refs.devicesPage.tableExport(command);
    },
    // qc记录导出
    QCReportExport(command) {
      this.$refs.QCReportPage.QCReportExport(command=='FQC明细报表');
    },
    // 检验单记录导出
    QCOrderExport(command) {
      this.$refs.QcCheckListPage.QCOrderExport(command);
    },
    RepairRecordExport() {
      this.$refs.RepairRecordPage.RepairRecordExport();
    },
    // 复制工序
    copySopBtn() {
      if (this.cutDetail == "process") {
        this.$refs.processPage.copySopBtn();
      }
    },
    // 添加按钮
    addNewBtn() {
      if (this.cutDetail == "process") {
        this.$refs.processPage.addNewBtn();
      }
    },
    // 判断id只能输入数字
    idInputChange(value, formName) {
      this.$set(this[formName], "id", this.$formatPositive(value));
    },
    // 当前工序改变
    workStationChange() {
      setTimeout(() => {
        this.$moreSearchStyle();
      }, 100);
    },
    // 上传记录仪的IMEI
    uploadImeiBtn() {
      this.$nextTick(() => {
        this.$refs.uploadImeiInput[0].click();
      });
    },
    // 上传电池SN按钮
    uploadBatteryBtn(index, type) {
      this.uploadType = type;
      this.$nextTick(() => {
        this.$refs.uploadBatteryInput[index].click();
      });
    },
    // 上传IMEI
    async uploadImeiChange() {
      this.uploadAndBind(
        0,
        "IMEI",
        "uploadImeiInput"
      );
    },
    // 确认上传电池SN
    async uploadBatteryChange(index) {
      this.uploadAndBind(
        index,
        "电池SN",
        "uploadBatteryInput"
      );
    },
    // 上传语言授权码按钮
    uploadVoiceBtn(index, type) {
      this.uploadType = type;
      this.$nextTick(() => {
        this.$refs.uploadVoiceInput[index].click();
      });
    },
    // 上传UUID按钮
    uploadUuidBtn(index, type) {
      this.uploadType = type;
      this.$nextTick(() => {
        this.$refs.uploadUuidInput[index].click();
      });
    },
    // 确认上传语言授权码
    async uploadVoiceChange(index) {
      this.uploadAndBind(
        index,
        "Voice",
        "uploadVoiceInput"
      );
    },
    // 确认上传ADAS
    async uploadUuidChange(index) {
      this.uploadAndBind(
        index,
        "UUID",
        "uploadUuidInput"
      );
    },
    // 上传MAC按钮
    uploadMacBtn(index, type) {
      this.uploadType = type;
      this.$nextTick(() => {
        this.$refs.uploadMacInput[index].click();
      });
    },
    // 确认上传MAC
    async uploadMacChange(index) {
      this.uploadAndBind(
        index,
        "MAC",
        "uploadMacInput"
      );
    },
    // 上传SN按钮
    uploadSnBtn(index, type) {
      this.uploadType = type;
      this.$nextTick(() => {
        this.$refs.uploadSnInput[index].click();
      });
    },
    // 确认上传SN
    async uploadSnChange(index) {
      this.uploadAndBind(
        index,
        "SN",
        "uploadSnInput"
      );
    },
    // 确认上传UUID
    async uploadUUIDChange(index) {
      this.uploadAndBind(
        index,
        "UUID",
        "uploadUUIDInput"
      );
    },
    // 上传 + 绑定
    async uploadAndBind(index, name, inputRef) {
      let files = this.$refs[inputRef][index].files;
      if (files.length) {
        let fd = new FormData();
        let res = {};
        if (this.uploadType == "file") {
          fd.append("file", files[0]);
          res = await apiUploadFile(fd);
        } else if (this.uploadType == "folder") {
          for (var i = 0; i < files.length; i++) {
            fd.append("folder", files[i]);
          }
          res = await apiUploadDolder(fd);
        }
        if (res.code == 0) {
          this.$refs[inputRef][index].value = "";
          const resBind = await apiProductionOrderBindFid({
            id: this.tabPaneData.id,
            fid: res.fid,
            type: name
          });
          if (resBind.code == 0) {
            if (name == "SN") {
              this.tabPaneData.importSn = true;
              this.tabPaneData.snFid = res.fid;
            } else if (name=="MAC") {
              this.tabPaneData.macFid=res.fid;
            } else if (name=="Voice") {
              this.tabPaneData.macFid=res.fid;
            } else if (name=="UUID") {
              this.tabPaneData.uuidFid=res.fid;
            }
            this.$refs.devicesPage.getProductionOrderDevices();
            this.$message({
              type: "success",
              message: `${name}导入成功！`,
            });
          }
        }
      }
    },
    // 关闭温馨提示
    closeTips() {
      this.isShowTips = false;
      this.$moreSearchStyle();
    },
    // 查询条件-员工
    selectVisible(value, orderName, labelName, origin) {
      if (value) {
        this.$refs.orderTableSelect.labelName = labelName;
        this.$refs.orderTableSelect.orderName = orderName;
        this.$refs.orderTableSelect.origin = origin;
        this.$refs.orderTableSelect.openDialog();
      }
    },
    // 员工选择表格提交
    orderTableSubmit({ orderName, selectRow, origin }) {
      this.$set(this[origin], `${orderName + "Id"}`, selectRow.id);
      this.$set(this.pullDownData, `${orderName + "List"}`, [selectRow]);
    },
    // 查询条件-产品类别改变
    productTypeChange(value) {
      this.$set(this.searchConditionForm, "productId", null);
      this.pullDownData.productList = [];
      if (value) {
        this.getProductList(value, "productList");
      }
    },
    // 查询条件--开始日期
    startDateChange(formName) {
      let { startDate, endDate } = this[formName];
      if (startDate > endDate) {
        this[formName].endDate = this[formName].startDate;
      }
    },
    // 查询条件--结束日期
    endDateChange(formName) {
      let { startDate, endDate } = this[formName];
      if (startDate > endDate) {
        this[formName].startDate = this[formName].endDate;
      }
    },
    // 查询条件--开始日期时间
    startDateTimeChange(formName) {
      let { startDateTime, endDateTime } = this[formName];
      if (startDateTime > endDateTime) {
        this[formName].endDateTime = this[formName].startDateTime;
      }
    },
    // 查询条件--结束日期时间
    endDateTimeChange(formName) {
      let { startDateTime, endDateTime } = this[formName];
      if (startDateTime > endDateTime) {
        this[formName].startDateTime = this[formName].endDateTime;
      }
    },
    // 表格数据排序
    sortChange({ prop, order }) {
      this.orderBy[0] = prop;
      if (order == "ascending") {
        this.desc = false;
      } else if (order == "descending") {
        this.desc = true;
      } else {
        this.desc = undefined;
        this.orderBy = [];
      }
      this.getProductionOrderSearch();
    },
    // 页码改变
    currentChange(val) {
      this.pagination.currentPage = val;
      this.getProductionOrderSearch();
    },
    // 页容量改变
    sizeChange(val) {
      this.pagination.currentPage = 1;
      this.pagination.pageSize = val;
      this.getProductionOrderSearch();
    },
    // 表格列组装工单点击
    clickAllowSkip(row) {
      this.nowRowData = row;
      this.tabPaneValue = row.id;
      let tabPaneIds = this.tabPaneList.map((item) => item.id);
      if (tabPaneIds.includes(row.id)) {
        this.tabPaneList.splice(tabPaneIds.indexOf(row.id), 1, row);
      } else {
        this.tabPaneList.push(row);
      }
    },
    // 客户名称下拉
    async getCustomerList() {
      const res = await apiCustomerList();
      if (res.code == 0) {
        this.pullDownData.customerList = res.data;
      }
    },
    // 产品类别下拉数据
    async getProductTypeList() {
      const res = await apiProductTypeList();
      if (res.code == 0) {
        this.pullDownData.productTypeList = res.data;
      }
    },
    // 产品型号下拉
    async getProductList(productType, name) {
      const res = await apiProductList({
        productType
      });
      if (res.code == 0) {
        this.pullDownData[name] = res.data;
      }
    },
    // 工单状态下拉
    async getOrderStatusList() {
      const res = await apiOrderStatusList();
      if (res.code == 0) {
        this.pullDownData.orderStatusList = res.data;
      }
    },
    // 产品列表-当前工序
    async getProductionOrderStatusList() {
      const res = await apiProductionOrderStatusList({
        all: true,
        id: this.tabPaneValue,
      });
      if (res.code == 0) {
        this.pullDownData.productionOrderStatusList = res.data;
      }
    },
    // 生产工序-工序下拉
    async getWorkStationList() {
      const res = await apiWorkStationList();
      if (res.code == 0) {
        this.pullDownData.workStationList = res.data;
      }
    },
    // QC报表-测试类型下拉
    async getQCTypeList() {
      const res = await apiQCTypeList();
      if (res.code == 0) {
        this.pullDownData.QCTypeList = res.data;
      }
    },
    // QC报表-测试对象类别下拉
    async getQCTargetTypeList() {
      const res = await apiQCTargetTypeList();
      if (res.code == 0) {
        this.pullDownData.QCTargetTypeList = res.data;
      }
    },
    // 生产日志--线体
    async getFactoryOrg() {
      const res = await apiFactoryOrgShow();
      // console.log(res);
      if (res.code == 0) {
        this.data = res.data;
        this.pullDownData.factoryOrgData = res.data.children;
      }
    },
    // 生产日志--工序下拉
    async getProductSopList() {
      const res = await apiProductSopList({
        orderId: this.tabPaneValue,
        typeId: 0,
        all: true,
      });
      if (res.code == 0) {
        this.pullDownData.productSopList = res.data;
      }
    },
    // 联级选择器改变时触发
    cascaderChange(val, ref) {
      val && this.$refs[ref].toggleDropDownVisible();
    },
    callback() {
      this.getCustomerList();
      this.getProductTypeList();
      this.getOrderStatusList();
      this.getWorkStationList();
      this.getQCTypeList();
      this.getQCTargetTypeList();
      this.getFactoryOrg();
    },
  },
  activated() {
    window.onresize = () => {
      document.querySelector(".contentBox").style.top =
        document.querySelector(".header").offsetHeight + "px";
    };
    if (this.tabPaneValue == "first") {
      if (this.cutView) {
        this.getProductionOrderSearch("", this.callback);
      } else {
        this.getProductionOrderCountByStatus(this.callback);
      }
    } else {
      if (this.cutDetail == "detail") {
        this.$refs.detailPage.getProductionOrderDetail(this.callback);
      } else if (this.cutDetail == "devices") {
        this.$refs.devicesPage.getProductionOrderDevices("", this.callback);
      } else if (this.cutDetail == "partList") {
        this.$refs.partListPage.getProOrderPartList("", this.callback);
      } else if (this.cutDetail == "status") {
        this.cutProStatus(this.proStatus, this.callback);
      } else if (this.cutDetail == "process") {
        this.$refs.processPage.getProductionLineData();
        this.$refs.processPage.getProductSopSearch("", this.callback);
      } else if (this.cutDetail == "QCReport") {
        this.$refs.QCReportPage.getProOrderQCReport("", this.callback);
      } else if (this.cutDetail == "proLog") {
        this.$refs.ProLogPage.getFactoryLogSearch("", false, this.callback);
      } else if (this.cutDetail == "uploadLog") {
        this.$refs.UploadLogPage.getUploadLogSearch("", false, this.callback);
      } else if (this.cutDetail == "QcCheckList") {
          this.$refs.QcCheckListPage.getQcCheckListSearch();
      } else if (this.cutDetail == "RepairRecordPage") {
          this.$refs.RepairRecordPage.getRepairSearch();
      }
      
    }
  },
  deactivated() {
    window.onresize = null;
  },
};
</script>

<style lang="less" scoped>
.assembleOrder {
  .chartView {
    width: 1100px;
    height: 100%;
    margin: 40px auto;
    .echartBtn {
      width: 120px;
      padding-right: 20px;
      float: left;
      button {
        min-width: 68px;
        margin-left: 0;
        margin-bottom: 10px;
      }
    }
    .myEchart,
    .statusEchart,
    .status2Echart,
    .partEchart {
      float: left;
      width: 950px;
      height: 480px;
      margin: 0 auto;
      border-radius: 5px;
      overflow: hidden;
    }
    .exceptionEchart {
      float: left;
      width: 950px;
      height: 680px;
      margin: 0 auto;
      border-radius: 5px;
      overflow: hidden;
    }
    .anomalyReportByDays {
      float: left;
      width: 950px;
      height: 480px;
      margin: 0 auto;
      border-radius: 5px;
      overflow: hidden;
    }
    .anomalyReportByHours {
      float: left;
      width: 950px;
      height: 480px;
      margin: 0 auto;
      border-radius: 5px;
      overflow: hidden;
    }
    .repairReportByDays {
      float: left;
      width: 950px;
      height: 680px;
      margin: 0 auto;
      border-radius: 5px;
      overflow: hidden;
    }
  }
  .tableView {
    height: 100%;
    display: flex;
    flex-direction: column;
  }
.icon-yiguoqi {
  margin-right: 3px;
  color: #f56c6c
}
.expire {
  color: #f56c6c
}
.downIcon {
  /deep/.el-icon-d-arrow-right {
    transform: rotateZ(90deg);
  }
}
.devicesDownloadDrop {
  transform: translateX(15px);
  .el-dropdown-menu__item {
    padding: 0 16px;
  }
  /deep/.popper__arrow {
    left: 46% !important;
  }
}
}
</style>
